import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import StatusProgres from '../../progressbar/StatusProgres';
import './chaptercontainercf.css';
import PracticeHelpPopup from '../bazelecontabilitatii/PracticeHelpPopup';
import changecard from '../../imagesHome/change-card.png';
import final_congrats_conti from '../../imagesHome/final_congrats_conti.png';
import confettyFinish from '../../imagesHome/confettyFinish.gif';
import finallessonprogress from '../../imagesHome/finallessonprogress.gif';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from "@fortawesome/free-regular-svg-icons";
import { useCallback } from 'react';
import levelUp from '../../header/images/level-up.mp3';
import error from '../../header/images/error.mp3';

import {faChevronLeft, faChevronRight, faCircleInfo, faMessage} from "@fortawesome/free-solid-svg-icons";
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import CustomAlertCf from '../../progressbar/CustomAlertCf'; 
import FeedbackPopup from '../../popuplessons/FeedbackPopup';
import ExplanationPopup from '../../popuplessons/ExplanationPopup';






  // Adaugă URL-ul API-ului folosind variabila de mediu
  const apiUrl = process.env.REACT_APP_API_URL;

  // Adaugă această funcție pentru a iniția vibrația pe dispozitivele compatibile
const triggerVibration = (pattern) => {
  if (navigator.vibrate) {
    navigator.vibrate(pattern);
  }
};

const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const getDecisionDragSlotsCount = (step) => {
  if (!step || typeof step !== 'object') return 0;

  const explicitSlotsCount = Number(step.slotsCount);
  if (Number.isFinite(explicitSlotsCount) && explicitSlotsCount > 0) {
    return explicitSlotsCount;
  }

  const rowsSlotsCount = Array.isArray(step.rows)
    ? step.rows.reduce((sum, row) => {
        const count = Number(row?.slots);
        return sum + (Number.isFinite(count) && count > 0 ? count : 0);
      }, 0)
    : 0;

  if (rowsSlotsCount > 0) {
    return rowsSlotsCount;
  }

  return Array.isArray(step.correctAnswer) ? step.correctAnswer.length : 0;
};

const isDecisionDragSimpleFormulaLayout = (step) => (
  step?.layout === 'sipleFormula' ||
  step?.variant === 'sipleFormula' ||
  step?.dragType === 'sipleFormula'
);

const buildDecisionOptionId = (index) => `decision-opt-${index}`;

const extractDecisionOptionIndex = (optionId) => {
  if (typeof optionId !== 'string') return -1;
  if (!optionId.startsWith('decision-opt-')) return -1;

  const value = Number(optionId.replace('decision-opt-', ''));
  return Number.isInteger(value) && value >= 0 ? value : -1;
};

const getDecisionOptionValueById = (step, optionId) => {
  const index = extractDecisionOptionIndex(optionId);
  if (index === -1) return null;

  if (!Array.isArray(step?.options)) return null;
  return step.options[index] ?? null;
};

const getQuestionType = (question) => {
  if (!question) return null;
  if (question.type === 'simpleFormula') return 'sipleFormula';
  if (question.type) return question.type;

  // Fallback pentru quizurile din GameFunctionalRules
  if (question.quizType === 'TeuCont') {
    return 'TeuCont';
  }

  if (
    question.quizType === 'singleAccount' ||
    question.quizType === 'oneAccount'
  ) {
    return 'oneAccount';
  }
  if (question.quizType === 'twoAccounts') {
    return 'twoAccounts';
  }

  // Fallback pentru quiz-ul de tip cont (modelul din GameTipeAccount)
  if (question.statement && question.correctType) {
    return 'typeAccountQuiz';
  }

  // Fallback pentru quiz-ul de plan de conturi (modelul din GameAccountsPlan)
  if (
    question.statement &&
    question.correctAccount &&
    Array.isArray(question.options) &&
    question.options.length > 0
  ) {
    return 'accountsPlanQuiz';
  }

  return null;
};

const getFunctionalRulesMode = (question, questionType) => {
  if (!question) return null;

  if (
    questionType === 'twoAccounts' ||
    question.quizType === 'twoAccounts'
  ) {
    return 'twoAccounts';
  }

  if (
    questionType === 'oneAccount' ||
    questionType === 'TeuCont' ||
    questionType === 'singleAccount' ||
    question.quizType === 'singleAccount' ||
    question.quizType === 'oneAccount' ||
    question.quizType === 'TeuCont'
  ) {
    return 'oneAccount';
  }

  return null;
};

const hasCompleteFunctionalRulesAnswer = (answers = [], mode, question) => {
  if (!mode || !question) return false;

  const expectedCount = mode === 'twoAccounts'
    ? Array.isArray(question.accounts) ? question.accounts.length : 0
    : 1;

  if (!Array.isArray(answers) || answers.length !== expectedCount) {
    return false;
  }

  return answers.every((answer) => answer?.side && answer?.variation);
};

const getTeuContTypeOptions = (question) => {
  if (Array.isArray(question?.teuContTypeOptions) && question.teuContTypeOptions.length > 0) {
    return question.teuContTypeOptions.map((item) => String(item));
  }

  if (Array.isArray(question?.typeOptions) && question.typeOptions.length > 0) {
    return question.typeOptions.map((item) => String(item));
  }

  return [];
};

const getTeuContAccountOptions = (question) => {
  if (Array.isArray(question?.teuContAccountOptions) && question.teuContAccountOptions.length > 0) {
    return question.teuContAccountOptions.map((item) => String(item));
  }

  if (Array.isArray(question?.accountOptions) && question.accountOptions.length > 0) {
    return question.accountOptions.map((item) => String(item));
  }

  if (question?.correctAccount !== undefined && question?.correctAccount !== null) {
    return [String(question.correctAccount)];
  }

  if (question?.account) {
    return [String(question.account)];
  }

  return [];
};

const getTeuContAmountOptions = (question) => {
  if (Array.isArray(question?.teuContAmountOptions) && question.teuContAmountOptions.length > 0) {
    return question.teuContAmountOptions.map((item) => String(item));
  }

  if (Array.isArray(question?.amountOptions) && question.amountOptions.length > 0) {
    return question.amountOptions.map((item) => String(item));
  }

  const hasDebitAmount = question?.correctAmountDebit !== undefined && question?.correctAmountDebit !== null;
  const hasCreditAmount = question?.correctAmountCredit !== undefined && question?.correctAmountCredit !== null;
  if (hasDebitAmount || hasCreditAmount) {
    const amounts = [];
    if (hasDebitAmount) amounts.push(String(question.correctAmountDebit));
    if (hasCreditAmount) amounts.push(String(question.correctAmountCredit));
    return amounts;
  }

  if (question?.correctAmount !== undefined && question?.correctAmount !== null) {
    return [String(question.correctAmount)];
  }

  if (question?.amount !== undefined && question?.amount !== null) {
    return [String(question.amount)];
  }

  return [];
};

const normalizeAccountsPlanOption = (option, index) => {
  if (option && typeof option === 'object' && option.account !== undefined) {
    return {
      ...option,
      account: String(option.account).trim(),
      __origIndex: index,
    };
  }

  // Acceptam si optiuni simple: 301, "301", etc.
  return {
    account: String(option).trim(),
    __origIndex: index,
  };
};


const Chaptercontainercf = () => {


  useEffect(() => {
  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = '';
  };

  window.addEventListener('beforeunload', handleBeforeUnload);

  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };
}, []);






useEffect(() => {
  document.documentElement.classList.add("quiz-active");
  document.body.classList.add("quiz-active");

  return () => {
    document.documentElement.classList.remove("quiz-active");
    document.body.classList.remove("quiz-active");
  };
}, []);



  const [hideActionButton, setHideActionButton] = useState(false);

const [showComments, setShowComments] = useState(false);

const [showPracticeHelp, setShowPracticeHelp] = useState(false);



const [showExplanationPopupModal, setShowExplanationPopupModal] = useState(false);






  
  
  const [showFeedback, setShowFeedback] = useState(false);

const handleShowFeedback = () => setShowFeedback(true);
const handleHideFeedback = () => setShowFeedback(false);


  const explanationRef = useRef(null);
  const [cardIndex, setCardIndex] = useState(0);
  const [leavingCardIndex, setLeavingCardIndex] = useState(null);
  const leaveCardTimerRef = useRef(null);

  const [coinCount, setCoinCount] = useState(0);
  const [showHeartPopup, setShowHeartPopup] = useState(false);

  const handleShowHeartPopup = () => {
    setShowHeartPopup(true);
  };
  
  const closeHeartPopup = () => {
    setShowHeartPopup(false);
  };

  const [showExplanationPopup, setShowExplanationPopup] = useState(false);




  const [showEyePopup, setShowEyePopup] = useState(false);

const handleShowEyePopup = () => {
  setShowEyePopup(true);
};

const closeEyePopup = () => {
  setShowEyePopup(false);
};



const [showAlert, setShowAlert] = useState(false);
const navigate = useNavigate(); // Inițializează navigate

const handleExitClick = () => {
  setShowAlert(true);
};

const handleConfirmExit = () => {
  setShowAlert(false);
  navigate('/functionalpagelogin');
};

const handleCancelExit = () => {
  setShowAlert(false);
};

const messageAlertClose = 
<div>
  <h3>Nu renunța!</h3>
  <p>Dacă părăsești această lecție, vei pierde progresul. Ești sigur?</p>
</div>;






  const location = useLocation();
  const {
    chapterId: chapterIdFromState,
    lessonId: lessonIdFromState,
    lessonData: lessonDataFromState
  } = location.state || {};

  const searchParams = new URLSearchParams(location.search);
  const chapterIdFromQuery = searchParams.get('chapterId');
  const lessonIdFromQuery = searchParams.get('lessonId');

  const chapterId = chapterIdFromState ?? chapterIdFromQuery ?? localStorage.getItem('cfActiveChapterId');
  const lessonIdRaw = lessonIdFromState ?? lessonIdFromQuery ?? localStorage.getItem('cfActiveLessonId');
  const lessonId = lessonIdRaw !== null && lessonIdRaw !== undefined && lessonIdRaw !== ''
    ? Number(lessonIdRaw)
    : null;
  const [lessonData, setLessonData] = useState(null);
  const [nextQuestion, setNextQuestion] = useState(0);

  const [isLessonFinished, setIsLessonFinished] = useState(false); // Stare pentru finalizarea lecției


  const [changeColorButton, setChangeColorButton] = useState(false);




  //stateuri pentru raspunsul corect

  const [simpleCorrectAnswer, setSimpleCorrectAnswer] = useState(false)




  // Funcția pentru a finaliza lecția și redirecționare

  const navigateToShowLesson = useNavigate();
  const finalizeLesson = () => {

    const lessonProgress = JSON.parse(localStorage.getItem('lessonProgress')) || {};

    const updatedProgress = {
      ...lessonProgress,
      [lessonId]: { ...lessonProgress[lessonId], completed: true },
      [lessonId + 1]: { ...lessonProgress[lessonId + 1], unlocked: true },
    };

    // Salvează progresul actualizat în localStorage
    localStorage.setItem('lessonProgress', JSON.stringify(updatedProgress));

    navigateToShowLesson('/functionalpagelogin', { state: { updatedProgress } });
  };


//functia pentru calcularea progresului

const calculateProgress = () => {
  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
    return 0; // Dacă datele nu sunt încă încărcate, progresul este 0%
  }

  const totalQuestions = Math.max(lessonData.questions.length - 1, 1);
  const answeredQuestions = Math.min(
    nextQuestion + (isAnswerChecked ? 1 : 0),
    totalQuestions
  );

  const progress = (answeredQuestions / totalQuestions) * 100; // Calculăm procentajul progresului

  return Math.min(progress, 100); // Ne asigurăm că nu depășește 100%
};







  //state pentru setarea mesajului

    // State pentru a stoca răspunsurile mutate
    const [dataReceived, setDataReceived] = useState([]);

 
// Funcția pentru a muta sau elimina răspunsul selectat
const toggleItem = (answer) => {
  setDataReceived((prev) => {
    let updatedData;
    
    if (prev.includes(answer)) {
      // Dacă răspunsul este deja mutat, îl eliminăm din dataReceived
      updatedData = prev.filter(item => item !== answer);
    } else {
      // Dacă răspunsul nu este mutat, îl adăugăm
      updatedData = [...prev, answer];
    }

    // Activăm sau dezactivăm butonul în funcție de conținutul array-ului dataReceived
    setDesableButton(updatedData.length === 0);  // Dezactivat dacă e gol, activat altfel
    setTextButton('Verifica');
    
    setChangeColorButton(true);


    return updatedData;
  });
};

// Verificăm dacă avem deja un răspuns mutat pentru acel index
const renderAnswer = (index) => {
  const code = dataReceived[index];
  const currentQuestion = lessonData.questions[nextQuestion];

  if (!code || !currentQuestion || !currentQuestion.options) return '';

  const option = currentQuestion.options.find(opt => opt.code === code);
  return option ? option.label : code;
};

     
 


const toNextQuestion = () => {
  resetQuestionState();

  setNextQuestion((prev) => {
    const newNextQuestion = prev + 1;

    // Dacă am ajuns la ultima întrebare → marchează lecția ca finalizată
    if (newNextQuestion >= lessonData.questions.length) {
      setIsLessonFinished(true);
      finalizeLesson();
      return prev; // ✅ rămâne pe ultima întrebare, nu trece peste array
    }

    return newNextQuestion;
  });
};


const updateCardIndexWithSwipe = useCallback((nextIndex) => {
  if (nextIndex === cardIndex) {
    return;
  }

  setLeavingCardIndex(cardIndex);

  if (leaveCardTimerRef.current) {
    clearTimeout(leaveCardTimerRef.current);
  }

  setCardIndex(nextIndex);

  leaveCardTimerRef.current = setTimeout(() => {
    setLeavingCardIndex(null);
    leaveCardTimerRef.current = null;
  }, 360);
}, [cardIndex]);


useEffect(() => {
  setCardIndex(0);
  setLeavingCardIndex(null);
}, [nextQuestion]);


useEffect(() => {
  return () => {
    if (leaveCardTimerRef.current) {
      clearTimeout(leaveCardTimerRef.current);
    }
  };
}, []);



useEffect(() => {
  if (explanationRef.current) {
    explanationRef.current.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } else {
    // fallback pentru tot documentul dacă nu ai explanationRef în pagină
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}, [nextQuestion]);


useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];
  if (getQuestionType(currentQuestion) === 'explanationLesson') {
    setHideActionButton(false);
    setDesableButton(false);  // activează butonul
    setTextButton('Continua');
  }
}, [nextQuestion, lessonData]);


 useEffect(() => {
  if (lessonDataFromState?.questions?.length) {
    setLessonData(lessonDataFromState);
    return;
  }

  if (chapterId && lessonId) {
    fetch(`${apiUrl}/contafinanciara/${chapterId}/lesson/${lessonId}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache"
      },
      credentials: 'include' // dacă backend-ul are sesiuni/cookies
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error('A apărut o eroare');
      }
      return response.json();
    })
    .then(data => {
      setLessonData(data);
    })
    .catch(err => {
      console.error(`Error: ${err}`);
    });
  }
}, [chapterId, lessonId, lessonDataFromState]);


useEffect(() => {
  if (chapterId && lessonId) {
    localStorage.setItem('cfActiveChapterId', String(chapterId));
    localStorage.setItem('cfActiveLessonId', String(lessonId));
  }
}, [chapterId, lessonId]);



// Folosim un string (sau null) pentru simpleSelectType, deoarece utilizatorul selectează o singură opțiune
const [simpleSelectType, setSimpleSelectType] = useState(null); //usestateul pentru stocarea raspusurilor simple select
const [shuffledOptions, setShuffledOptions] = useState([]);
const [shuffledMultipleOptions, setShuffledMultipleOptions] = useState([]);
const [shuffledDragHorizontalOptions, setShuffledDragHorizontalOptions] = useState([]);
const [shuffledSipleFormulaOptions, setShuffledSipleFormulaOptions] = useState([]);
const [shuffledMultipleFormulaLeftOptions, setShuffledMultipleFormulaLeftOptions] = useState([]);
const [shuffledMultipleFormulaRightOptions, setShuffledMultipleFormulaRightOptions] = useState([]);
const [shuffledDecisionOptions, setShuffledDecisionOptions] = useState([]);
const [shuffledDecisionDragOptions, setShuffledDecisionDragOptions] = useState([]);
const [shuffledDecisionSipleFormulaOptions, setShuffledDecisionSipleFormulaOptions] = useState([]);
const [shuffledDecisionMfrOptions, setShuffledDecisionMfrOptions] = useState([]);
const [shuffledDecisionMflOptions, setShuffledDecisionMflOptions] = useState([]);
const [decisionStepIndex, setDecisionStepIndex] = useState(0);
const [decisionAnswer, setDecisionAnswer] = useState(null);
const [decisionMultipleAnswers, setDecisionMultipleAnswers] = useState([]);
const [decisionDragAnswers, setDecisionDragAnswers] = useState([]);
const [decisionSipleFormulaData, setDecisionSipleFormulaData] = useState([]);
const [decisionMfrData, setDecisionMfrData] = useState([]);
const [decisionMflData, setDecisionMflData] = useState([]);
const [decisionPhase, setDecisionPhase] = useState('intro');
const [functionalRulesAnswers, setFunctionalRulesAnswers] = useState([]);
const [teuContTypeDrop, setTeuContTypeDrop] = useState(null);
const [teuContAccountDrop, setTeuContAccountDrop] = useState(null);
const [teuContDebitAmountDrop, setTeuContDebitAmountDrop] = useState(null);
const [teuContCreditAmountDrop, setTeuContCreditAmountDrop] = useState(null);
const [teuContAmountTargetSide, setTeuContAmountTargetSide] = useState(null);
const [teuContTypeSourceKey, setTeuContTypeSourceKey] = useState(null);
const [teuContAccountSourceKey, setTeuContAccountSourceKey] = useState(null);
const [teuContDebitAmountSourceKey, setTeuContDebitAmountSourceKey] = useState(null);
const [teuContCreditAmountSourceKey, setTeuContCreditAmountSourceKey] = useState(null);
const [selectedAccountOption, setSelectedAccountOption] = useState(null);
const [availableAccountOptions, setAvailableAccountOptions] = useState([]);
const [userInput, setUserInput] = useState({});  // Răspunsul introdus de utilizator
const [selectedAnswers, setSelectedAnswers] = useState([]); // Răspunsurile bifate de utilizator
const [message, setMessage] = useState('');
const [textButton, setTextButton] = useState('')

useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];

  if (currentQuestion?.type === 'simpleSelect') {
    setShuffledOptions(shuffleArray(currentQuestion.options));
    setShuffledMultipleOptions([]);
    setShuffledDragHorizontalOptions([]);
    setShuffledSipleFormulaOptions([]);
    setShuffledMultipleFormulaLeftOptions([]);
    setShuffledMultipleFormulaRightOptions([]);
  } else if (currentQuestion?.type === 'multipleSelect') {
    setShuffledMultipleOptions(shuffleArray(currentQuestion.options));
    setShuffledOptions([]);
    setShuffledDragHorizontalOptions([]);
    setShuffledSipleFormulaOptions([]);
    setShuffledMultipleFormulaLeftOptions([]);
    setShuffledMultipleFormulaRightOptions([]);
  } else if (currentQuestion?.type === 'dragAndDropHorizontal') {
    setShuffledDragHorizontalOptions(shuffleArray(currentQuestion.options));
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledSipleFormulaOptions([]);
    setShuffledMultipleFormulaLeftOptions([]);
    setShuffledMultipleFormulaRightOptions([]);
  } else if (getQuestionType(currentQuestion) === 'sipleFormula') {
    setShuffledSipleFormulaOptions(shuffleArray(currentQuestion.options || []));
    setShuffledMultipleFormulaLeftOptions([]);
    setShuffledMultipleFormulaRightOptions([]);
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledDragHorizontalOptions([]);
  } else if (getQuestionType(currentQuestion) === 'multipleFormulaLeft') {
    setShuffledMultipleFormulaLeftOptions(shuffleArray(currentQuestion.options || []));
    setShuffledMultipleFormulaRightOptions([]);
    setShuffledSipleFormulaOptions([]);
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledDragHorizontalOptions([]);
  } else if (getQuestionType(currentQuestion) === 'multipleFormulaRight') {
    setShuffledMultipleFormulaRightOptions(shuffleArray(currentQuestion.options || []));
    setShuffledMultipleFormulaLeftOptions([]);
    setShuffledSipleFormulaOptions([]);
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledDragHorizontalOptions([]);
  } else {
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledDragHorizontalOptions([]);
    setShuffledSipleFormulaOptions([]);
    setShuffledMultipleFormulaLeftOptions([]);
    setShuffledMultipleFormulaRightOptions([]);
  }
}, [lessonData, nextQuestion]);

useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];
  const questionType = getQuestionType(currentQuestion);

  if (questionType === 'accountsPlanQuiz') {
    const opts = (currentQuestion.options || []).map((option, idx) =>
      normalizeAccountsPlanOption(option, idx)
    );
    setAvailableAccountOptions(opts);
    setSelectedAccountOption(null);
  } else {
    setAvailableAccountOptions([]);
    setSelectedAccountOption(null);
  }
}, [lessonData, nextQuestion]);

useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];
  const questionType = getQuestionType(currentQuestion);
  const mode = getFunctionalRulesMode(currentQuestion, questionType);

  if (!mode) {
    setFunctionalRulesAnswers([]);
    return;
  }

  const accountCount = mode === 'twoAccounts'
    ? Array.isArray(currentQuestion?.accounts) ? currentQuestion.accounts.length : 0
    : 1;

  setFunctionalRulesAnswers(
    Array.from({ length: accountCount }, () => ({ side: null, variation: null }))
  );
}, [lessonData, nextQuestion]);

useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];
  const questionType = getQuestionType(currentQuestion);

  if (questionType !== 'TeuCont') {
    setTeuContTypeDrop(null);
    setTeuContAccountDrop(null);
    setTeuContDebitAmountDrop(null);
    setTeuContCreditAmountDrop(null);
    setTeuContAmountTargetSide(null);
    setTeuContTypeSourceKey(null);
    setTeuContAccountSourceKey(null);
    setTeuContDebitAmountSourceKey(null);
    setTeuContCreditAmountSourceKey(null);
    return;
  }

  setTeuContTypeDrop(null);
  setTeuContAccountDrop(null);
  setTeuContDebitAmountDrop(null);
  setTeuContCreditAmountDrop(null);
  setTeuContAmountTargetSide(null);
  setTeuContTypeSourceKey(null);
  setTeuContAccountSourceKey(null);
  setTeuContDebitAmountSourceKey(null);
  setTeuContCreditAmountSourceKey(null);
}, [lessonData, nextQuestion]);

// Safety net: dacă opțiunile vin corect din backend dar state-ul local rămâne gol,
// reinițializăm lista ca să evităm randarea doar a placeholderelor.
useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];
  const questionType = getQuestionType(currentQuestion);

  if (
    questionType === 'accountsPlanQuiz' &&
    Array.isArray(currentQuestion?.options) &&
    currentQuestion.options.length > 0 &&
    availableAccountOptions.length === 0 &&
    !selectedAccountOption
  ) {
    setAvailableAccountOptions(
      currentQuestion.options.map((option, idx) => normalizeAccountsPlanOption(option, idx))
    );
  }
}, [lessonData, nextQuestion, availableAccountOptions.length, selectedAccountOption]);

useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];

  if (getQuestionType(currentQuestion) !== 'decisionFlowApplication') {
    setShuffledDecisionOptions([]);
    setShuffledDecisionDragOptions([]);
    return;
  }

  const step = currentQuestion?.steps?.[decisionStepIndex];
  if (!step) {
    setShuffledDecisionOptions([]);
    setShuffledDecisionDragOptions([]);
    return;
  }

  if (step.type === 'decizionDragAndDrop') {
    const dragOptions = Array.isArray(step.options)
      ? step.options.map((value, index) => ({
          id: buildDecisionOptionId(index),
          value,
          label: String(value),
        }))
      : [];

    setShuffledDecisionDragOptions(shuffleArray(dragOptions));
    setShuffledDecisionOptions([]);
    setShuffledDecisionSipleFormulaOptions([]);
    return;
  }

  if (step.type === 'decizionSipleFormula') {
    setShuffledDecisionSipleFormulaOptions(shuffleArray(step.options || []));
    setShuffledDecisionOptions([]);
    setShuffledDecisionDragOptions([]);
    setShuffledDecisionMfrOptions([]);
    return;
  }

  if (step.type === 'decizionMultipleFormulaRight') {
    setShuffledDecisionMfrOptions(shuffleArray(step.options || []));
    setShuffledDecisionOptions([]);
    setShuffledDecisionDragOptions([]);
    setShuffledDecisionSipleFormulaOptions([]);
    setShuffledDecisionMflOptions([]);
    return;
  }

  if (step.type === 'decizionMultipleFormulaLeft') {
    setShuffledDecisionMflOptions(shuffleArray(step.options || []));
    setShuffledDecisionOptions([]);
    setShuffledDecisionDragOptions([]);
    setShuffledDecisionSipleFormulaOptions([]);
    setShuffledDecisionMfrOptions([]);
    return;
  }

  setShuffledDecisionOptions(shuffleArray(step.options || []));
  setShuffledDecisionDragOptions([]);
  setShuffledDecisionSipleFormulaOptions([]);
  setShuffledDecisionMfrOptions([]);
  setShuffledDecisionMflOptions([]);
}, [lessonData, nextQuestion, decisionStepIndex]);

useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];

  if (getQuestionType(currentQuestion) !== 'decisionFlowApplication') {
    setDecisionDragAnswers([]);
    setDecisionSipleFormulaData([]);
    return;
  }

  const step = currentQuestion?.steps?.[decisionStepIndex];

  if (step?.type === 'decizionDragAndDrop') {
    const slotsCount = getDecisionDragSlotsCount(step);
    setDecisionDragAnswers(Array(slotsCount).fill(null));
    setDecisionSipleFormulaData([]);
    return;
  }

  if (step?.type === 'decizionSipleFormula') {
    const slotsCount = Array.isArray(step.correctAnswer) && step.correctAnswer.length > 0
      ? step.correctAnswer.length
      : 4;
    setDecisionSipleFormulaData(Array(slotsCount).fill(null));
    setDecisionDragAnswers([]);
    setDecisionMfrData([]);
    return;
  }

  if (step?.type === 'decizionMultipleFormulaRight') {
    const slotsCount = Array.isArray(step.correctAnswer) && step.correctAnswer.length > 0
      ? step.correctAnswer.length
      : 8;
    setDecisionMfrData(Array(slotsCount).fill(null));
    setDecisionDragAnswers([]);
    setDecisionSipleFormulaData([]);
    setDecisionMflData([]);
    return;
  }

  if (step?.type === 'decizionMultipleFormulaLeft') {
    const slotsCount = Array.isArray(step.correctAnswer) && step.correctAnswer.length > 0
      ? step.correctAnswer.length
      : 8;
    setDecisionMflData(Array(slotsCount).fill(null));
    setDecisionDragAnswers([]);
    setDecisionSipleFormulaData([]);
    setDecisionMfrData([]);
    return;
  }

  setDecisionDragAnswers([]);
  setDecisionSipleFormulaData([]);
  setDecisionMfrData([]);
  setDecisionMflData([]);
}, [lessonData, nextQuestion, decisionStepIndex]);

useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];

  if (getQuestionType(currentQuestion) === 'decisionFlowApplication') {
    setDecisionPhase('intro');
    setDecisionStepIndex(0);
    setDecisionAnswer(null);
    setDecisionMultipleAnswers([]);
    setDecisionDragAnswers([]);
    setDecisionSipleFormulaData([]);
    setDecisionMfrData([]);
    setDecisionMflData([]);
  }
}, [nextQuestion, lessonData]);

useEffect(() => {
  if(isLessonFinished) {
  setTextButton('Continua');

} else {
  setTextButton('Continua')
}
  
}, [isLessonFinished])


const [isAnswerChecked, setIsAnswerChecked] = useState(false); //urmaresc daca raspunsul a fost verificat


const buttonTextChange = () => {

  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
    return <p>Loading lesson...</p>;
  }
  const currentQuestion = lessonData.questions[nextQuestion]; 
  const questionType = getQuestionType(currentQuestion);

  switch (questionType) {
    case 'explanationLesson':
      setTextButton('Continua00000');
      break;

    case 'lessonCompletion':
      setTextButton('Continua');
      break;

    case 'simpleSelect':
      setTextButton('Verifica')
      setChangeColorButton(true)
      break;

    case 'typeAccountQuiz':
      setTextButton('Verifica');
      setChangeColorButton(true);
      break;

    case 'accountsPlanQuiz':
      setTextButton('Verifica');
      setChangeColorButton(true);
      break;

    case 'oneAccount':
    case 'TeuCont':
    case 'twoAccounts':
      setTextButton('Verifica');
      setChangeColorButton(true);
      break;

    case 'manualInput':
      
      break;

    case 'dragAndDrop':
      setTextButton('Verifica');
     
      
      break;

      case 'dragAndDropHorizontal':
        setTextButton('Verifica');
       
        
        break;

        case 'dragAndDropOneAnswer':
          setTextButton('Verifica');
         
          
          break;

        case 'sipleFormula':
          setTextButton('Verifica');
          break;

        case 'multipleFormulaLeft':
          setTextButton('Verifica');
          break;

        case 'multipleFormulaRight':
          setTextButton('Verifica');
          break;

        case 'decisionFlowApplication':
          setTextButton(decisionPhase === 'steps' ? 'Verifica' : 'Continua');
          break;


    case 'multipleSelect':
      setTextButton('Verifica')
     
      break;

    default:
      
  }
};


const [desableButon, setDesableButton] = useState(false);
//functia pentru dezactivarea butonului






useEffect(() => {
  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
      return;
  }

  const currentQuestion = lessonData.questions[nextQuestion];
  const questionType = getQuestionType(currentQuestion);

  // Resetare stări pentru fiecare nouă întrebare
  setIsAnswerChecked(false);
  setSimpleSelectType(null);
  setSelectedAccountOption(null);
  setAvailableAccountOptions([]);
  setFunctionalRulesAnswers([]);
  setMessage('');
  setSimpleCorrectAnswer(false);  // Ascunde răspunsul corect

  // Dacă tipul întrebării necesită selecție, dezactivează butonul
    if (['simpleSelect', 'typeAccountQuiz', 'accountsPlanQuiz', 'oneAccount', 'TeuCont', 'twoAccounts', 'manualInput', 'dragAndDrop', 'dragAndDropHorizontal', 'dragAndDropOneAnswer', 'sipleFormula', 'multipleFormulaLeft', 'multipleFormulaRight', 'multipleSelect'].includes(questionType)) {
      setDesableButton(true);
  } else {
      // Activați butonul pentru explanationLesson și lessonResume
      setDesableButton(false);
  }
}, [nextQuestion, lessonData]);


const [answerStatus, setAnswerStatus] = useState(null); // Starea pentru corect/greșit/null


const resetQuestionState = () => {
  setSelectedAnswers([]);
  setSimpleSelectType(null);
  setSelectedAccountOption(null);
  setAvailableAccountOptions([]);
  setFunctionalRulesAnswers([]);
  setTeuContTypeDrop(null);
  setTeuContAccountDrop(null);
  setTeuContDebitAmountDrop(null);
  setTeuContCreditAmountDrop(null);
  setTeuContAmountTargetSide(null);
  setTeuContTypeSourceKey(null);
  setTeuContAccountSourceKey(null);
  setTeuContDebitAmountSourceKey(null);
  setTeuContCreditAmountSourceKey(null);
  setDecisionPhase('intro');
  setDecisionStepIndex(0);
  setDecisionAnswer(null);
  setDecisionMultipleAnswers([]);
  setDecisionDragAnswers([]);
  setDecisionSipleFormulaData([]);
  setDecisionMfrData([]);
  setDecisionMflData([]);
  setShuffledDecisionOptions([]);
  setShuffledDecisionDragOptions([]);
  setShuffledDecisionSipleFormulaOptions([]);
  setShuffledDecisionMfrOptions([]);
  setShuffledDecisionMflOptions([]);
  setUserInput({});
  setIsAnswerChecked(false);
  setSimpleCorrectAnswer(false);
  setAnswerStatus(null);
  setMessage('');
  setDataReceived([]);
  setTextButton('');
  setChangeColorButton(false);
  setDesableButton(true);
  setShowCorrectAnswer(false);
};



// Adăugăm o stare pentru a controla afișarea răspunsului corect
const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);
const [isLessonCompletionBarDoneCf, setIsLessonCompletionBarDoneCf] = useState(false);


useEffect(() => {
  const activeQuestionType = lessonData?.questions?.[nextQuestion]?.type;

  if (activeQuestionType === 'lessonCompletion') {
    setIsLessonCompletionBarDoneCf(false);
  }
}, [nextQuestion, lessonData]);




  //functia de verificare a raspunsurilor
  
  const verifyAnswer = () => {

       if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
      return <p>Loading lesson...</p>;
    }
    const currentQuestion = lessonData.questions[nextQuestion]; 
    const questionType = getQuestionType(currentQuestion);

    switch (questionType) {
      case 'explanationLesson':
        setDesableButton(false); // Activează butonul
  setHideActionButton(false); // Asigură afișarea
  setTextButton('Continua');  // Textul corect
  setIsAnswerChecked(true);   // Marchează că s-a „verificat”
        break;

      case 'simpleSelect':
          if (!isAnswerChecked) {
              setDesableButton(true); // Dezactivați butonul la începutul întrebării
              if (currentQuestion.correctAnswer === simpleSelectType) {
                setMessage(''); // Folosește numele real al array-ului

                  setAnswerStatus('correct');
                  const audioUp = new Audio(levelUp);
                  audioUp.play();
                  setCoinCount(prev => prev + 1);
                  triggerVibration(200);
                  setDesableButton(false); // Activează butonul după verificarea răspunsului
              } else {
                  setMessage(''); 
                  setAnswerStatus('incorrect');
                  const audioErr = new Audio(error);
                  audioErr.play();
                  setSimpleCorrectAnswer(currentQuestion.correctAnswer);
                  triggerVibration([300, 100, 300]);
                  setDesableButton(false);
              }
              setIsAnswerChecked(true);
              setTextButton('Continua');
              setShowCorrectAnswer(false);
              setChangeColorButton(false);
          } else {
              // Trecem la următoarea întrebare
              setIsAnswerChecked(false);
              setSimpleSelectType(null);
              setMessage('');
              setTextButton('Continua');
              toNextQuestion();
              setShowCorrectAnswer(false);
          }
          break;

      case 'typeAccountQuiz':
        if (!isAnswerChecked) {
          if (simpleSelectType === currentQuestion.correctType) {
            setMessage('');
            setAnswerStatus('correct');
            const audioUp = new Audio(levelUp);
            audioUp.play();
            setCoinCount(prev => prev + 1);
            triggerVibration(200);
          } else {
            setMessage('');
            setAnswerStatus('incorrect');
            const audioErr = new Audio(error);
            audioErr.play();
            triggerVibration([300, 100, 300]);
          }

          setIsAnswerChecked(true);
          setTextButton('Continua');
          setShowCorrectAnswer(false);
          setChangeColorButton(false);
          setDesableButton(false);
        } else {
          setIsAnswerChecked(false);
          setSimpleSelectType(null);
          setMessage('');
          setTextButton('Continua');
          toNextQuestion();
          setShowCorrectAnswer(false);
        }
        break;

      case 'accountsPlanQuiz':
        if (!isAnswerChecked) {
          if (!selectedAccountOption) {
            return;
          }

          if (
            String(selectedAccountOption.account).trim() === String(currentQuestion.correctAccount).trim()
          ) {
            setMessage('');
            setAnswerStatus('correct');
            const audioUp = new Audio(levelUp);
            audioUp.play();
            setCoinCount(prev => prev + 1);
            triggerVibration(200);
          } else {
            setMessage('');
            setAnswerStatus('incorrect');
            const audioErr = new Audio(error);
            audioErr.play();
            triggerVibration([300, 100, 300]);
          }

          setIsAnswerChecked(true);
          setTextButton('Continua');
          setShowCorrectAnswer(false);
          setChangeColorButton(false);
          setDesableButton(false);
        } else {
          setIsAnswerChecked(false);
          setSelectedAccountOption(null);
          setAvailableAccountOptions([]);
          setMessage('');
          setTextButton('Continua');
          toNextQuestion();
          setShowCorrectAnswer(false);
        }
        break;

      case 'oneAccount': {
        if (!isAnswerChecked) {
          const answer = functionalRulesAnswers?.[0];
          if (!answer?.side || !answer?.variation) {
            return;
          }

          const isCorrect =
            answer.side === currentQuestion.correctSide &&
            answer.variation === currentQuestion.correctVariation;

          if (isCorrect) {
            setMessage('');
            setAnswerStatus('correct');
            const audioUp = new Audio(levelUp);
            audioUp.play();
            setCoinCount(prev => prev + 1);
            triggerVibration(200);
          } else {
            setMessage('');
            setAnswerStatus('incorrect');
            const audioErr = new Audio(error);
            audioErr.play();
            triggerVibration([300, 100, 300]);
          }

          setIsAnswerChecked(true);
          setTextButton('Continua');
          setShowCorrectAnswer(false);
          setChangeColorButton(false);
          setDesableButton(false);
        } else {
          setIsAnswerChecked(false);
          setFunctionalRulesAnswers([]);
          setMessage('');
          setTextButton('Continua');
          toNextQuestion();
          setShowCorrectAnswer(false);
        }
        break;
      }

      case 'TeuCont': {
        if (!isAnswerChecked) {
          const expectedAccount = String(
            currentQuestion.correctAccount ?? currentQuestion.account ?? ''
          );
          const expectedDebitAmount = currentQuestion.correctAmountDebit !== undefined && currentQuestion.correctAmountDebit !== null
            ? String(currentQuestion.correctAmountDebit)
            : (currentQuestion.correctSide === 'D'
              ? String(currentQuestion.correctAmount ?? currentQuestion.amount ?? '')
              : '');
          const expectedCreditAmount = currentQuestion.correctAmountCredit !== undefined && currentQuestion.correctAmountCredit !== null
            ? String(currentQuestion.correctAmountCredit)
            : (currentQuestion.correctSide === 'C'
              ? String(currentQuestion.correctAmount ?? currentQuestion.amount ?? '')
              : '');
          const enteredDebitAmount = String(teuContDebitAmountDrop ?? '');
          const enteredCreditAmount = String(teuContCreditAmountDrop ?? '');

          const isCorrect =
            teuContTypeDrop === currentQuestion.correctType &&
            teuContAccountDrop === expectedAccount &&
            enteredDebitAmount === expectedDebitAmount &&
            enteredCreditAmount === expectedCreditAmount;

          if (isCorrect) {
            setMessage('');
            setAnswerStatus('correct');
            const audioUp = new Audio(levelUp);
            audioUp.play();
            setCoinCount(prev => prev + 1);
            triggerVibration(200);
          } else {
            setMessage('');
            setAnswerStatus('incorrect');
            const audioErr = new Audio(error);
            audioErr.play();
            triggerVibration([300, 100, 300]);
          }

          setIsAnswerChecked(true);
          setTextButton('Continua');
          setShowCorrectAnswer(false);
          setChangeColorButton(false);
          setDesableButton(false);
        } else {
          setIsAnswerChecked(false);
          setTeuContTypeDrop(null);
          setTeuContAccountDrop(null);
          setTeuContDebitAmountDrop(null);
          setTeuContCreditAmountDrop(null);
          setTeuContAmountTargetSide(null);
          setTeuContTypeSourceKey(null);
          setTeuContAccountSourceKey(null);
          setTeuContDebitAmountSourceKey(null);
          setTeuContCreditAmountSourceKey(null);
          setMessage('');
          setTextButton('Continua');
          toNextQuestion();
          setShowCorrectAnswer(false);
        }
        break;
      }

      case 'twoAccounts': {
        if (!isAnswerChecked) {
          const isCorrect = Array.isArray(currentQuestion.accounts)
            ? currentQuestion.accounts.every((acc, index) => {
                const answer = functionalRulesAnswers?.[index];
                return (
                  answer?.side === acc.correctSide &&
                  answer?.variation === acc.correctVariation
                );
              })
            : false;

          if (isCorrect) {
            setMessage('');
            setAnswerStatus('correct');
            const audioUp = new Audio(levelUp);
            audioUp.play();
            setCoinCount(prev => prev + 1);
            triggerVibration(200);
          } else {
            setMessage('');
            setAnswerStatus('incorrect');
            const audioErr = new Audio(error);
            audioErr.play();
            triggerVibration([300, 100, 300]);
          }

          setIsAnswerChecked(true);
          setTextButton('Continua');
          setShowCorrectAnswer(false);
          setChangeColorButton(false);
          setDesableButton(false);
        } else {
          setIsAnswerChecked(false);
          setFunctionalRulesAnswers([]);
          setMessage('');
          setTextButton('Continua');
          toNextQuestion();
          setShowCorrectAnswer(false);
        }
        break;
      }

      case 'manualInput':
        if (!isAnswerChecked) {
          // Verificăm dacă toate răspunsurile sunt corecte
          let allCorrect = true;
          currentQuestion.correctAnswer.forEach((answer, index) => {
            // Comparam răspunsul utilizatorului cu codul corect
            if (Number(userInput[index]) !== answer.code) {
              allCorrect = false;
            }
          });
          if (allCorrect) {
           setMessage('');
            setAnswerStatus('correct');
            const audioUp = new Audio(levelUp);
                audioUp.play();
            setSimpleCorrectAnswer(false);
            setCoinCount(prev => prev + 1);
            // Vibrație scurtă pentru răspuns corect
          triggerVibration(200); // 200ms pentru un răspuns corect
          } else {
            setMessage('');

            setAnswerStatus('incorrect');
            const audioErr = new Audio(error);
            audioErr.play();
            setSimpleCorrectAnswer(currentQuestion.correctAnswer.map((newAnswer) => {
             return <div>{newAnswer.code}:{newAnswer.label}</div>
            }));
            triggerVibration([300, 100, 300]);
          }
          setIsAnswerChecked(true);  // Marchez răspunsul ca verificat
          setTextButton('Continua');  // Schimb textul butonului la "Continuă"
          setChangeColorButton(false)
          setDesableButton(false); // Activăm butonul după verificare pentru a permite utilizatorului să continue
        } else {
          // A doua fază: Trecem la următoarea întrebare
          setIsAnswerChecked(false);  // Resetează starea de verificare
          setUserInput({});  // Resetează input-urile utilizatorului
          setMessage('');  // Resetează mesajul
          setTextButton('Continua');  // Resetează textul butonului la "Verifică"
          setChangeColorButton(false);
          toNextQuestion();  // Trecem la următoarea întrebare
        }
        break;

      case 'decisionFlowApplication': {
        const step = currentQuestion?.steps?.[decisionStepIndex];
        if (!step) {
          return;
        }

        const isMultipleStep = step.type === 'dicizionMultiple';
        const isDragStep = step.type === 'decizionDragAndDrop';
        const isSipleFormulaStep = step.type === 'decizionSipleFormula';
        const isMfrStep = step.type === 'decizionMultipleFormulaRight';
        const isMflStep = step.type === 'decizionMultipleFormulaLeft';
        const expectedAnswers = Array.isArray(step.correctAnswer) ? step.correctAnswer : [];
        const selectedDecisionAnswers = Array.isArray(decisionMultipleAnswers) ? decisionMultipleAnswers : [];
        const selectedDecisionDragAnswers = Array.isArray(decisionDragAnswers) ? decisionDragAnswers : [];
        const selectedDecisionDragValues = selectedDecisionDragAnswers.map((optionId) => getDecisionOptionValueById(step, optionId));
        const sipleFormulaUserAnswers = Array.isArray(decisionSipleFormulaData)
          ? decisionSipleFormulaData.map((item) => (item === null || item === undefined ? '' : String(item)))
          : [];
        const sipleFormulaExpected = expectedAnswers.map((item) => String(item));
        const mfrUserAnswers = Array.isArray(decisionMfrData)
          ? decisionMfrData.map((item) => (item === null || item === undefined ? '' : String(item)))
          : [];
        const mfrExpectedOrdered = expectedAnswers.map((item) => String(item));
        const mflUserAnswers = Array.isArray(decisionMflData)
          ? decisionMflData.map((item) => (item === null || item === undefined ? '' : String(item)))
          : [];

        const isDecisionCorrect = isMultipleStep
          ? JSON.stringify([...selectedDecisionAnswers].sort()) === JSON.stringify([...expectedAnswers].sort())
          : isDragStep
          ? JSON.stringify(selectedDecisionDragValues) === JSON.stringify(expectedAnswers)
          : isSipleFormulaStep
          ? sipleFormulaUserAnswers.length === sipleFormulaExpected.length &&
            sipleFormulaExpected.every((val, idx) => sipleFormulaUserAnswers[idx] === val)
          : isMfrStep
          ? mfrUserAnswers.length === mfrExpectedOrdered.length &&
            mfrExpectedOrdered.every((val, idx) => mfrUserAnswers[idx] === val)
          : isMflStep
          ? mflUserAnswers.length === mfrExpectedOrdered.length &&
            mfrExpectedOrdered.every((val, idx) => mflUserAnswers[idx] === val)
          : decisionAnswer === step.correctAnswer;

        if (isDecisionCorrect) {
          setMessage('');
          setAnswerStatus('correct');
          const audioUp = new Audio(levelUp);
          audioUp.play();
          setCoinCount(prev => prev + 1);
          triggerVibration(200);
        } else {
          setMessage('');
          setAnswerStatus('incorrect');
          const audioErr = new Audio(error);
          audioErr.play();
          if (isMultipleStep) {
            setSimpleCorrectAnswer(expectedAnswers);
          } else if (isDragStep) {
            setSimpleCorrectAnswer(expectedAnswers.map((item, idx) => <div key={idx}>{item}</div>));
          } else if (isSipleFormulaStep) {
            setSimpleCorrectAnswer(sipleFormulaExpected.map((item, idx) => <div key={idx}>{item}</div>));
          } else if (isMfrStep) {
            setSimpleCorrectAnswer(mfrExpectedOrdered.map((item, idx) => <div key={idx}>{item}</div>));
          } else if (isMflStep) {
            setSimpleCorrectAnswer(mfrExpectedOrdered.map((item, idx) => <div key={idx}>{item}</div>));
          }
          triggerVibration([300, 100, 300]);
        }

        setIsAnswerChecked(true);
        break;
      }

      case 'dragAndDrop':
        if (!isAnswerChecked) {
          // Verificăm dacă răspunsurile mutate de utilizator sunt corecte
          if (JSON.stringify(dataReceived) === JSON.stringify(currentQuestion.correctAnswer)) {
            setMessage('');
            const audioUp = new Audio(levelUp);
                audioUp.play();
            setSimpleCorrectAnswer(false);
            setCoinCount(prev => prev + 1);
            triggerVibration(200);
          } else {
           setMessage('');
            setAnswerStatus('incorrect');
            const audioErr = new Audio(error);
            audioErr.play();
            setSimpleCorrectAnswer(currentQuestion.correctAnswer.map((newAnswer) => {
              return <div>{newAnswer}</div>
             }));
            // Vibrație mai lungă pentru răspuns greșit
          triggerVibration([300, 100, 300]); // Vibrație cu pauză pentru răspuns greșit
          }
          setIsAnswerChecked(true);  // Marchez răspunsul ca verificat
          setTextButton('Continuă6');  // Schimb textul butonului la "Continuă"
          setChangeColorButton(false);
            // Activez butonul pentru a permite trecerea la următoarea întrebare
        } else {
          // A doua fază: Trecem la următoarea întrebare
          setIsAnswerChecked(false);  // Resetează starea de verificare
          setDataReceived([]);  // Resetează răspunsurile mutate
          setMessage('');  // Resetează mesajul
          setTextButton('Continuă5');  // Resetează textul butonului la "Verifică"
          setChangeColorButton(false);
            // Dezactivează butonul pentru a forța verificarea înainte de a continua
          toNextQuestion();  // Trecem la următoarea întrebare
        }
        break;

     case 'dragAndDropHorizontal':
  if (!isAnswerChecked) {
    const expected = currentQuestion.correctAnswer.filter(
      (_, index) => index % 2 === 1
    );

    const userAnswers = dataReceived.filter(
      v => v !== null && v !== undefined
    );

    const isCorrect =
      userAnswers.length === expected.length &&
      userAnswers.every((value, index) => value === expected[index]);

    if (isCorrect) {
      setMessage('');
      const audioUp = new Audio(levelUp);
      audioUp.play();
      setSimpleCorrectAnswer(false);
      setCoinCount(prev => prev + 1);
      triggerVibration(200);
      setAnswerStatus('correct');
    } else {
      setMessage('');
      setAnswerStatus('incorrect');
      const audioErr = new Audio(error);
      audioErr.play();
      setSimpleCorrectAnswer(expected.map((item, idx) => <div key={idx}>{item}</div>));
      triggerVibration([300, 100, 300]);
    }

    setIsAnswerChecked(true);
    setChangeColorButton(false);
  } else {
    const blanksCount = currentQuestion.correctAnswer.filter(
      (_, index) => index % 2 === 1
    ).length;

    setDataReceived(Array(blanksCount).fill(null));
    setIsAnswerChecked(false);
    setMessage('');
    setChangeColorButton(false);
    toNextQuestion();
  }
  break;


        case 'dragAndDropOneAnswer':
          if (!isAnswerChecked) {
            const userAnswer = dataReceived[0];
            const correctAnswer = currentQuestion.correctAnswer[1]; // poziția cuvântului lipsă
        
            if (userAnswer === correctAnswer) {
             setMessage('');
              const audioUp = new Audio(levelUp);
              audioUp.play();
              setCoinCount(prev => prev + 1);
              triggerVibration(200);
              setAnswerStatus('correct');
              setSimpleCorrectAnswer(false);
            } else {
              setMessage('');
              const audioErr = new Audio(error);
              audioErr.play();
              setSimpleCorrectAnswer(<div>{correctAnswer}</div>);
              triggerVibration([300, 100, 300]);
              setAnswerStatus('incorrect');
            }
        
            setIsAnswerChecked(true);
            setTextButton('Continua');
            setChangeColorButton(false);
          } else {
            setIsAnswerChecked(false);
            setDataReceived([]); // un singur element, deci reset total
            setMessage('');
            setTextButton('Verifica');
            setChangeColorButton(false);
            toNextQuestion();
          }
          break;

      case 'sipleFormula':
      case 'multipleFormulaLeft':
      case 'multipleFormulaRight': {
        if (!isAnswerChecked) {
          const expected = Array.isArray(currentQuestion.correctAnswer)
            ? currentQuestion.correctAnswer.map((item) => String(item))
            : [];

          const userAnswers = Array.isArray(dataReceived)
            ? dataReceived.map((item) => item === null || item === undefined ? '' : String(item))
            : [];

          const isCorrect =
            userAnswers.length === expected.length &&
            expected.every((value, index) => userAnswers[index] === value);

          if (isCorrect) {
            setMessage('');
            setAnswerStatus('correct');
            const audioUp = new Audio(levelUp);
            audioUp.play();
            setCoinCount(prev => prev + 1);
            triggerVibration(200);
          } else {
            setMessage('');
            setAnswerStatus('incorrect');
            const audioErr = new Audio(error);
            audioErr.play();
            setSimpleCorrectAnswer(expected.map((item, idx) => <div key={idx}>{item}</div>));
            triggerVibration([300, 100, 300]);
          }

          setIsAnswerChecked(true);
          setTextButton('Continua');
          setChangeColorButton(false);
          setDesableButton(false);
        } else {
          const slotsCount = Array.isArray(currentQuestion.correctAnswer)
            ? currentQuestion.correctAnswer.length
            : 4;

          setDataReceived(Array(slotsCount).fill(null));
          setIsAnswerChecked(false);
          setMessage('');
          setTextButton('Verifica');
          setChangeColorButton(false);
          toNextQuestion();
        }
        break;
      }
        
      case 'multipleSelect':
        if (!isAnswerChecked) {
          // Verificăm dacă răspunsurile selectate de utilizator sunt corecte
          const sortedSelected = [...selectedAnswers].sort();  // Sortăm o copie pentru comparație
          const sortedCorrect = [...currentQuestion.correctAnswer].sort();  // Sortăm răspunsurile corecte
          
          if (JSON.stringify(sortedSelected) === JSON.stringify(sortedCorrect)) {
           setMessage('');
            setAnswerStatus('correct');
            const audioUp = new Audio(levelUp);
                audioUp.play();
            setSimpleCorrectAnswer(false);
            setCoinCount(prev => prev + 1);
            triggerVibration(200);
          } else {
            setMessage('');
            setAnswerStatus('incorrect');
            const audioErr = new Audio(error);
                audioErr.play();
            setSimpleCorrectAnswer(currentQuestion.correctAnswer);
            triggerVibration([300, 100, 300]);
          }
          setIsAnswerChecked(true);  // Marchez răspunsul ca verificat
          setTextButton('Continua');  // Schimb textul butonului la "Continua"
          setChangeColorButton(false);
        } else {
          // A doua fază: Trecem la următoarea întrebare
          setIsAnswerChecked(false);  // Resetează starea de verificare
          setSelectedAnswers([]);  // Resetează răspunsurile selectate
          setMessage('');  // Resetează mesajul
          setTextButton('Continua');  // Resetează textul butonului la "Verifică"
          setChangeColorButton(false);
          toNextQuestion();  // Trecem la următoarea întrebare
        }
        break;
        case 'lessonResume':

      
         
          setIsLessonFinished(true)
        
        break;
      default:
       <p>'Tipul întrebării nu este recunoscut'</p> 
    }
  };
  

  const handleInputChange = (index, value) => {
    const updatedInput = {
      ...userInput,
      [index]: value  // Actualizăm răspunsul pentru fiecare index
    };
    
    setUserInput(updatedInput);

   
  
    // Verificăm dacă s-au introdus date în cel puțin un câmp de input
    const hasData = Object.values(updatedInput).some(val => val.trim() !== '');
    
    // Schimbăm textul butonului dacă există input
    if (hasData) {
      setTextButton('Verifică888888888');
    
      setChangeColorButton(true);
    } else {
      setTextButton('Continua12');
    }
  };
 



// Funcția pentru a actualiza răspunsurile selectate
const handleCheckboxChange = (option) => {
  setSelectedAnswers(prevSelected => {
    let updatedSelected;
    
    if (prevSelected.includes(option)) {
      // Dacă opțiunea este deja selectată, o eliminăm din array
      updatedSelected = prevSelected.filter(answer => answer !== option);
    } else {
      // Adăugăm opțiunea selectată
      updatedSelected = [...prevSelected, option];
    }
    
    // Verificăm dacă mai sunt opțiuni selectate
    setDesableButton(updatedSelected.length === 0); // Dezactivează butonul dacă nu e nimic selectat
    return updatedSelected; // Returnează lista actualizată de răspunsuri selectate
  });

  // După fiecare schimbare, setăm textul butonului la "Verifică"
  setTextButton('Verifica');
 
  setChangeColorButton(true);
};

const handleFunctionalRulesSelect = (index, side, variation) => {
  if (isAnswerChecked) return;

  setFunctionalRulesAnswers((prev) => {
    const updated = [...prev];
    updated[index] = { side, variation };
    return updated;
  });

  setChangeColorButton(true);
  setTextButton('Verifica');
};

const areAllFieldsCompleted = useCallback(() => {
  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
    return false;
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  if (!currentQuestion) return false;

  switch (currentQuestion.type) {
    case 'dragAndDrop':
      return dataReceived.length === currentQuestion.correctAnswer.length &&
             currentQuestion.correctAnswer.every(answer => dataReceived.includes(answer));
    case 'dragAndDropHorizontal':
      return dataReceived.every(val => val !== null && val !== undefined);
    case 'dragAndDropOneAnswer':
      return dataReceived.length === 1 && dataReceived[0] !== null && dataReceived[0] !== undefined;
    case 'sipleFormula':
    case 'multipleFormulaLeft':
    case 'multipleFormulaRight':
      return (
        Array.isArray(dataReceived) &&
        dataReceived.length > 0 &&
        dataReceived.every((val) => val !== null && val !== undefined)
      );
    default:
      return true;
  }
  
}, [lessonData, nextQuestion, dataReceived]);



useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];
  const questionType = getQuestionType(currentQuestion);

  if (questionType === 'dragAndDropHorizontal') {
    const blanks = currentQuestion.correctAnswer
      .map((_, i) => i)
      .filter(i => i % 2 === 1); // indecsi impari = sloturi
    setDataReceived(Array(blanks.length).fill(null));
  } else if (questionType === 'dragAndDropOneAnswer') {
    setDataReceived([null]);
  } else if (questionType === 'sipleFormula' || questionType === 'multipleFormulaLeft' || questionType === 'multipleFormulaRight') {
    const slotsCount = Array.isArray(currentQuestion?.correctAnswer) && currentQuestion.correctAnswer.length > 0
      ? currentQuestion.correctAnswer.length
      : 4;
    setDataReceived(Array(slotsCount).fill(null));
  }
}, [nextQuestion, lessonData]);





useEffect(() => {
  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
    return;
  }

  const currentQuestion = lessonData.questions[nextQuestion];
  const questionType = getQuestionType(currentQuestion);

  switch (questionType) {
    case 'simpleSelect':
      // Dezactivăm butonul dacă nu s-a selectat încă un răspuns
      setDesableButton(simpleSelectType === null);
      break;

    case 'typeAccountQuiz':
      // Quiz Activ/Pasiv: butonul devine activ doar după selecție
      setDesableButton(simpleSelectType === null);
      break;

    case 'accountsPlanQuiz':
      // Quiz plan conturi: butonul devine activ doar după ce avem un cont în blank
      setDesableButton(selectedAccountOption === null);
      break;

    case 'oneAccount':
    case 'twoAccounts': {
      const mode = getFunctionalRulesMode(currentQuestion, questionType);
      setDesableButton(!hasCompleteFunctionalRulesAnswer(functionalRulesAnswers, mode, currentQuestion));
      break;
    }

    case 'TeuCont':
      setDesableButton(!(teuContTypeDrop || teuContAccountDrop || teuContDebitAmountDrop || teuContCreditAmountDrop));
      break;

    case 'multipleSelect':
      // Dezactivăm butonul dacă nu s-a selectat încă un răspuns
      setDesableButton(selectedAnswers.length === 0);
      break;

    case 'manualInput':
      // Verificăm dacă toate câmpurile de input sunt completate
      const allFilled = currentQuestion.correctAnswer.every((_, idx) => {
        return userInput[idx] && userInput[idx].trim() !== '';
      });
      setDesableButton(!allFilled);
      break;

    case 'dragAndDrop':
      // Verificăm dacă toate elementele au fost mutate corect
      setDesableButton(!areAllFieldsCompleted());
      break;

      case 'dragAndDropHorizontal':
      // Verificăm dacă toate elementele au fost mutate corect
      setDesableButton(!areAllFieldsCompleted());
      break;
      case 'dragAndDropOneAnswer':
      // Verificăm dacă toate elementele au fost mutate corect
      setDesableButton(!areAllFieldsCompleted());
      break;

    case 'sipleFormula':
    case 'multipleFormulaLeft':
    case 'multipleFormulaRight':
      setDesableButton(!areAllFieldsCompleted());
      break;

      case 'decisionFlowApplication':
        if (decisionPhase === 'steps') {
          const step = currentQuestion?.steps?.[decisionStepIndex];
          if (step?.type === 'dicizionMultiple') {
            setDesableButton(decisionMultipleAnswers.length === 0);
          } else if (step?.type === 'decizionDragAndDrop') {
            const slotsCount = getDecisionDragSlotsCount(step);
            const allFilled =
              slotsCount > 0 &&
              decisionDragAnswers.length === slotsCount &&
              decisionDragAnswers.every((value) => value !== null && value !== undefined && value !== '');
            setDesableButton(!allFilled);
          } else if (step?.type === 'decizionSipleFormula') {
            const sfSlotsCount = Array.isArray(step.correctAnswer) ? step.correctAnswer.length : 4;
            const sfAllFilled =
              sfSlotsCount > 0 &&
              decisionSipleFormulaData.length === sfSlotsCount &&
              decisionSipleFormulaData.every((v) => v !== null && v !== undefined && v !== '');
            setDesableButton(!sfAllFilled);
          } else if (step?.type === 'decizionMultipleFormulaRight') {
            const dmfrSlotsCount = Array.isArray(step.correctAnswer) ? step.correctAnswer.length : 8;
            const dmfrAllFilled =
              dmfrSlotsCount > 0 &&
              decisionMfrData.length === dmfrSlotsCount &&
              decisionMfrData.every((v) => v !== null && v !== undefined && v !== '');
            setDesableButton(!dmfrAllFilled);
          } else if (step?.type === 'decizionMultipleFormulaLeft') {
            const dmflSlotsCount = Array.isArray(step.correctAnswer) ? step.correctAnswer.length : 8;
            const dmflAllFilled =
              dmflSlotsCount > 0 &&
              decisionMflData.length === dmflSlotsCount &&
              decisionMflData.every((v) => v !== null && v !== undefined && v !== '');
            setDesableButton(!dmflAllFilled);
          } else {
            setDesableButton(decisionAnswer === null);
          }
        } else {
          setDesableButton(false);
        }
        break;

    default:
      // Activăm butonul pentru explanationLesson și lessonResume
      setDesableButton(false);
      break;
  }
  }, [simpleSelectType, selectedAccountOption, selectedAnswers, userInput, dataReceived, functionalRulesAnswers, teuContTypeDrop, teuContAccountDrop, teuContDebitAmountDrop, teuContCreditAmountDrop, nextQuestion, lessonData, areAllFieldsCompleted, decisionPhase, decisionAnswer, decisionStepIndex, decisionMultipleAnswers, decisionDragAnswers, decisionSipleFormulaData, decisionMfrData, decisionMflData]);








const renderContent = () => {
  // dacă am trecut de ultima întrebare, nu mai randăm conținut de întrebare
  if (!lessonData || !lessonData.questions) return null;
  if (nextQuestion >= lessonData.questions.length) return null;

  const currentQuestion = lessonData.questions[nextQuestion];
  const questionType = getQuestionType(currentQuestion);

  
   
    switch (questionType) {

      case 'explanationLesson':
        return (
          <div className="quiz-content-scroll-bc-cf">
          <div ref={explanationRef} className='explanation-lesoon-container-text-cf'>
            <div className='description-lesson-text-explanation-bc-cf'>
              {/* Show card-dots only if more than one paragraph */}
              {currentQuestion?.type === 'explanationLesson' &&
                Array.isArray(currentQuestion.descriptionExplanation) &&
                currentQuestion.descriptionExplanation.length > 1 && (
                  <div className="card-dots-cf">
                    {currentQuestion.descriptionExplanation.map((_, i) => (
                      <span
                        key={i}
                        className={`dot-cf ${i === cardIndex ? 'active-cf' : ''}`}
                        onClick={() => updateCardIndexWithSwipe(i)}
                      />
                    ))}
                  </div>
                )}

              {/* CARDURI CONTROLATE */}
              <div className="card-stack-container-cf">
                {currentQuestion.descriptionExplanation.map((explanation, index) => {
                  const totalCards = currentQuestion.descriptionExplanation.length;
                  const offset = (index - cardIndex + totalCards) % totalCards;
                  const isLeavingCard = index === leavingCardIndex;

                  if (offset > 1 && !isLeavingCard) return null;

                  const cardStateClass = isLeavingCard
                    ? 'leaving-cf'
                    : offset === 0
                    ? 'active-cf'
                    : 'next-cf';

                  return (
                    <div
                      key={index}
                      className={`explanation-card-bc-cf ${cardStateClass}`}
                      style={{
                        transform:
                          isLeavingCard
                            ? 'translateX(120%) rotate(7deg) scale(0.93)'
                            : offset === 0
                            ? 'translateY(0) scale(0.95)'
                            : 'translateY(0px) translateX(0px) scale(0.96) rotate(2deg)',
                        zIndex: isLeavingCard ? 12 : 10 - offset,
                        opacity: isLeavingCard ? 0 : offset === 0 ? 1 : 0.5
                      }}
                    >
                      <div
                        className="text-size-emplanation-bc-cf"
                        dangerouslySetInnerHTML={{ __html: explanation }}
                      />
                    </div>
                  );
                })}
              </div>
      
              {/* Afisare imagine sub text, daca exista */}
              {currentQuestion.image && (
                <div className="lesson-image-container-cf">
                  <img
                    src={currentQuestion.image}
                    alt="Explicatie lectie"
                    className="lesson-image-cf"
                  />
                </div>
              )}
            </div>
          </div>
          </div>
        );
      

      case 'simpleSelect':
        return (
          <div className="quiz-content-scroll-cf">
          <div className='explanation-lesoon-container-cf'>
           
            <div className='tittle-sescrition-lesson-cf title-simple-select-align-cf'>

            <div className="centred-simple-element-cf">
              <span className="question-text-cf">{currentQuestion.question}</span>
             
            </div>

              

            </div>
            <div className='simple-select-buttons-description-cf'>
    {(shuffledOptions.length ? shuffledOptions : currentQuestion.options).map((option) => {
      let className = 'simple-Button-select-cf';

      if (isAnswerChecked) {
        if (option === currentQuestion.correctAnswer) {
          className = 'simple-Button-select-correct-cf';
        } else if (option === simpleSelectType) {
          className = 'simple-Button-select-incorrect-cf';
        }
      } else if (simpleSelectType === option) {
        className = 'simple-Button-select-colored-cf';
      }

      return (
        <button
          key={option}
          className={className}
          onClick={() => {
            setSimpleSelectType(option);
            buttonTextChange();
            setDesableButton(false);
          }}
          disabled={isAnswerChecked}
        >
          <p>{option}</p>
        </button>
      );
    })}
</div>


            
          </div>
          </div>
        );

      case 'typeAccountQuiz':
        {
          const rawStatement = String(currentQuestion.statement || '').trim();
          const accountNumber = String(currentQuestion.accountNumber || '').trim();
          const hasAccountPrefix =
            accountNumber.length > 0 && rawStatement.startsWith(accountNumber);
          const displayStatement =
            accountNumber.length > 0 && !hasAccountPrefix
              ? `${accountNumber} ${rawStatement}`.trim()
              : rawStatement;

        return (
          <div className="quiz-content-scroll-cf">
            <div className='type-account-quiz-shell-cf'>
              

              <div className='title-simple-select-align-cf type-account-statement-wrap-cf'>
                <p
                  className='question-text-cf type-account-statement-typeaccount-cf'
                  dangerouslySetInnerHTML={{ __html: displayStatement }}
                />
              </div>


              <p className='type-account-title-cf'>este cont de:</p>

              <div className='simple-select-buttons-description-cf type-account-options-row-cf'>
                {['Activ', 'Pasiv'].map((option) => {
                  let className = 'type-account-option-cf';

                  if (isAnswerChecked) {
                    if (option === currentQuestion.correctType) {
                      className = 'type-account-option-cf type-account-option-correct-cf';
                    } else if (option === simpleSelectType) {
                      className = 'type-account-option-cf type-account-option-incorrect-cf';
                    }
                  } else if (simpleSelectType === option) {
                    className = 'type-account-option-cf type-account-option-selected-cf';
                  }

                  return (
                    <button
                      key={option}
                      className={className}
                      onClick={() => {
                        setSimpleSelectType(option);
                        buttonTextChange();
                        setDesableButton(false);
                      }}
                      disabled={isAnswerChecked}
                    >
                      <p>{option}</p>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        );
      }

      case 'accountsPlanQuiz': {
        const normalizedOptions = (currentQuestion.options || []).map((option, idx) =>
          normalizeAccountsPlanOption(option, idx)
        );

        const selectedAccountKey = selectedAccountOption
          ? String(selectedAccountOption.account)
          : null;

        // Comportament identic cu GameAccountsPlan: disponibile = toate opțiunile minus cea selectată în blank.
        const effectiveAvailableOptions = normalizedOptions.filter(
          (opt) => String(opt.account) !== selectedAccountKey
        );

        const onDragStartOption = (event, account) => {
          if (isAnswerChecked) return;
          event.dataTransfer.setData('text/plain', String(account));
          event.dataTransfer.effectAllowed = 'move';
        };

        const onDragOverBlank = (event) => {
          event.preventDefault();
        };

        const onDropOnBlank = (event) => {
          event.preventDefault();
          if (isAnswerChecked) return;

          const account = event.dataTransfer.getData('text/plain');
          if (!account) return;

          const pickedOption = normalizedOptions.find(
            (opt) => String(opt.account) === String(account)
          );

          if (!pickedOption) return;

          setSelectedAccountOption(pickedOption);
          setAvailableAccountOptions(
            normalizedOptions.filter((opt) => String(opt.account) !== String(account))
          );
          setIsAnswerChecked(false);
          setShowFeedback(false);
          setAnswerStatus(null);
          setChangeColorButton(true);
          setDesableButton(false);
          buttonTextChange();
        };

        const onDragStartBlank = (event) => {
          if (!selectedAccountOption || isAnswerChecked) return;
          event.dataTransfer.setData('text/plain', `fromBlank:${selectedAccountOption.account}`);
          event.dataTransfer.effectAllowed = 'move';
        };

        const onDropOnOptionsArea = (event) => {
          event.preventDefault();
          if (isAnswerChecked) return;

          const raw = event.dataTransfer.getData('text/plain');
          if (!raw || !raw.startsWith('fromBlank:')) return;

          const account = raw.slice('fromBlank:'.length);
          if (selectedAccountOption && String(selectedAccountOption.account) === String(account)) {
            setSelectedAccountOption(null);
            setAvailableAccountOptions(normalizedOptions);
            setIsAnswerChecked(false);
            setShowFeedback(false);
            setAnswerStatus(null);
            setChangeColorButton(false);
            setDesableButton(true);
          }
        };

        const onSelectByClick = (account) => {
          if (isAnswerChecked) return;

          const optionObj = normalizedOptions.find(
            (opt) => String(opt.account) === String(account)
          );

          if (!optionObj) return;

          setSelectedAccountOption(optionObj);
          setAvailableAccountOptions(
            normalizedOptions.filter((opt) => String(opt.account) !== String(account))
          );
          setIsAnswerChecked(false);
          setShowFeedback(false);
          setAnswerStatus(null);
          setChangeColorButton(true);
          setDesableButton(false);
          buttonTextChange();
        };

        const onBlankClick = () => {
          if (!selectedAccountOption || isAnswerChecked) return;
          setSelectedAccountOption(null);
          setAvailableAccountOptions(normalizedOptions);
          setIsAnswerChecked(false);
          setShowFeedback(false);
          setAnswerStatus(null);
          setChangeColorButton(false);
          setDesableButton(true);
        };

        return (
          <div className="quiz-content-scroll-cf">
            <div className='accounts-plan-quiz-shell-cf'>
             

              <div className="accounts-plan-statement-cf">
                <div className="accounts-plan-blank-row-cf">
                  <div
                    className={`accounts-plan-blank-box-cf ${selectedAccountOption ? 'filled' : ''} ${
                      isAnswerChecked
                        ? answerStatus === 'correct'
                          ? 'correct'
                          : 'incorrect'
                        : ''
                    }`}
                    onDragOver={onDragOverBlank}
                    onDrop={onDropOnBlank}
                    role="button"
                    tabIndex={0}
                    draggable={!!selectedAccountOption && !isAnswerChecked}
                    onDragStart={onDragStartBlank}
                    onClick={onBlankClick}
                    aria-label={
                      selectedAccountOption
                        ? `Cont selectat ${selectedAccountOption.account}`
                        : 'Loc gol - plaseaza contul'
                    }
                  >
                    {selectedAccountOption ? (
                      <span className="accounts-plan-blank-value-cf">{selectedAccountOption.account}</span>
                    ) : (
                      <span className="accounts-plan-blank-placeholder-cf"></span>
                    )}
                  </div>
                </div>

                <div
                  className="accounts-plan-text-cf"
                  dangerouslySetInnerHTML={{ __html: currentQuestion.statement || '' }}
                />
              </div>


               <p className='type-account-title-cf'>alege codul contului:</p>

              <div className="accounts-plan-options-cf">
                <div
                  className="accounts-plan-options-row-cf"
                  onDragOver={(event) => event.preventDefault()}
                  onDrop={onDropOnOptionsArea}
                  role="list"
                >
                  {normalizedOptions.map((originalOption) => {
                    const isAvailable = effectiveAvailableOptions.some(
                      (opt) => String(opt.account) === String(originalOption.account)
                    );

                    const isSelected =
                      selectedAccountOption &&
                      String(selectedAccountOption.account) === String(originalOption.account);

                    const isCorrect =
                      isAnswerChecked &&
                      String(originalOption.account).trim() === String(currentQuestion.correctAccount).trim();

                    const isIncorrect =
                      isAnswerChecked &&
                      isSelected &&
                      String(originalOption.account).trim() !== String(currentQuestion.correctAccount).trim();

                    if (isAvailable) {
                      const optionObj = effectiveAvailableOptions.find(
                        (opt) => String(opt.account) === String(originalOption.account)
                      );

                      return (
                        <button
                          key={originalOption.account}
                          className={`accounts-plan-option-btn-cf ${
                            isSelected ? 'selected' : ''
                          } ${isCorrect ? 'correct' : ''} ${isIncorrect ? 'incorrect' : ''}`}
                          draggable={!isAnswerChecked}
                          onDragStart={(event) => onDragStartOption(event, optionObj.account)}
                          onClick={() => onSelectByClick(optionObj.account)}
                          disabled={isAnswerChecked}
                          aria-label={`Optiune cont ${optionObj.account}`}
                        >
                          <div className="accounts-plan-opt-number-cf">{optionObj.account}</div>
                        </button>
                      );
                    }

                    return (
                      <div
                        key={`ph-${originalOption.account}`}
                        className="accounts-plan-option-placeholder-cf"
                        aria-hidden
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        );
      }

      case 'TeuCont': {
        const typeOptions = getTeuContTypeOptions(currentQuestion);
        const accountOptions = getTeuContAccountOptions(currentQuestion);
        const amountOptions = getTeuContAmountOptions(currentQuestion);
        const allTeuContOptions = [
          ...typeOptions.map((option) => ({ key: `type-${option}`, group: 'type', value: String(option) })),
          ...accountOptions.map((option) => ({ key: `account-${option}`, group: 'account', value: String(option) })),
          ...amountOptions.map((option) => ({ key: `amount-${option}`, group: 'amount', value: String(option) })),
        ];

        const statementHtml = currentQuestion.statement || currentQuestion.context || '';

        const onDropSlot = (event, slot) => {
          event.preventDefault();
          if (isAnswerChecked) return;

          const raw = event.dataTransfer.getData('application/json');
          if (!raw) return;

          try {
            const payload = JSON.parse(raw);
            if (!payload || typeof payload !== 'object') return;

            if (slot === 'type' && payload.group === 'type') {
              setTeuContTypeDrop(payload.value);
              setTeuContTypeSourceKey(payload.key || `type-${payload.value}`);
            }

            if (slot === 'account' && payload.group === 'account') {
              setTeuContAccountDrop(payload.value);
              setTeuContAccountSourceKey(payload.key || `account-${payload.value}`);
            }

            if (slot === 'debitAmount' && payload.group === 'amount') {
              setTeuContDebitAmountDrop(payload.value);
              setTeuContDebitAmountSourceKey(payload.key || `amount-${payload.value}`);
              setTeuContAmountTargetSide('D');
            }

            if (slot === 'creditAmount' && payload.group === 'amount') {
              setTeuContCreditAmountDrop(payload.value);
              setTeuContCreditAmountSourceKey(payload.key || `amount-${payload.value}`);
              setTeuContAmountTargetSide('C');
            }

            setChangeColorButton(true);
            setTextButton('Verifica');
          } catch (err) {
            console.error(err);
          }
        };

        const onDragOver = (event) => {
          event.preventDefault();
        };

        const placeOptionInNextAvailableSlot = (optionItem) => {
          if (isAnswerChecked) return;

          if (!optionItem) return;

          const optionValue = String(optionItem.value);
          const optionKey = String(optionItem.key);

          if (!teuContTypeDrop) {
            setTeuContTypeDrop(optionValue);
            setTeuContTypeSourceKey(optionKey);
          } else if (!teuContAccountDrop) {
            setTeuContAccountDrop(optionValue);
            setTeuContAccountSourceKey(optionKey);
          } else if (teuContAmountTargetSide === 'C' && !teuContCreditAmountDrop) {
            setTeuContCreditAmountDrop(optionValue);
            setTeuContCreditAmountSourceKey(optionKey);
          } else if (teuContAmountTargetSide === 'D' && !teuContDebitAmountDrop) {
            setTeuContDebitAmountDrop(optionValue);
            setTeuContDebitAmountSourceKey(optionKey);
          } else if (!teuContDebitAmountDrop) {
            setTeuContDebitAmountDrop(optionValue);
            setTeuContDebitAmountSourceKey(optionKey);
            setTeuContAmountTargetSide('D');
          } else if (!teuContCreditAmountDrop) {
            setTeuContCreditAmountDrop(optionValue);
            setTeuContCreditAmountSourceKey(optionKey);
            setTeuContAmountTargetSide('C');
          } else {
            // Cand toate sloturile sunt deja completate, suprascriem suma din partea selectata.
            if (teuContAmountTargetSide === 'C') {
              setTeuContCreditAmountDrop(optionValue);
              setTeuContCreditAmountSourceKey(optionKey);
            } else {
              setTeuContDebitAmountDrop(optionValue);
              setTeuContDebitAmountSourceKey(optionKey);
            }
          }

          setChangeColorButton(true);
          setTextButton('Verifica');
        };

        const renderDropClass = (value, expectedValue) => {
          if (!isAnswerChecked) return 'teu-cont-drop-zone-cf';
          if (value === null || value === undefined || value === '') return 'teu-cont-drop-zone-cf teu-cont-drop-zone-disabled-cf';
          const ok = value === expectedValue;
          return `teu-cont-drop-zone-cf ${ok ? 'teu-cont-drop-zone-correct-cf' : 'teu-cont-drop-zone-incorrect-cf'}`;
        };

        return (
          <div className="quiz-content-scroll-cf">
            <div className='functional-rules-shell-cf'>
              <div
                className='functional-rules-statement-cf'
                dangerouslySetInnerHTML={{ __html: statementHtml }}
              />

              <div className='functional-t-account-cf teu-cont-t-account-cf'>
                <div className='functional-teu-header-cf teu-cont-header-cf'>
                  <div
                    onDragOver={onDragOver}
                    onDrop={(event) => onDropSlot(event, 'type')}
                    onClick={() => {
                      if (isAnswerChecked) return;
                      setTeuContTypeDrop(null);
                      setTeuContTypeSourceKey(null);
                    }}
                    className={`${renderDropClass(teuContTypeDrop, String(currentQuestion.correctType || ''))} teu-cont-drop-zone-header-cf teu-cont-drop-zone-header-top-cf ${teuContTypeDrop ? 'teu-cont-drop-zone-filled-cf' : ''}`}
                  >
                    {teuContTypeDrop || 'tip cont'}
                  </div>

                  <div className='teu-cont-second-header-row-cf'>
                    <div className='functional-debit-cf teu-cont-debit-label-cf'>D</div>

                    <div className='teu-cont-header-center-cf'>
                    <div
                      onDragOver={onDragOver}
                      onDrop={(event) => onDropSlot(event, 'account')}
                      onClick={() => {
                        if (isAnswerChecked) return;
                        setTeuContAccountDrop(null);
                        setTeuContAccountSourceKey(null);
                      }}
                      className={`${renderDropClass(
                        teuContAccountDrop,
                        String(currentQuestion.correctAccount ?? currentQuestion.account ?? '')
                      )} teu-cont-drop-zone-header-cf ${teuContAccountDrop ? 'teu-cont-drop-zone-filled-cf' : ''}`}
                    >
                      {teuContAccountDrop || 'cod cont'}
                    </div>
                    </div>

                    <div className='functional-credit-cf teu-cont-credit-label-cf'>C</div>
                  </div>
                </div>

                <div className='functional-t-body-cf'>
                  <div className='functional-t-side-group-cf teu-cont-side-full-cf'>
                    <div
                      onDragOver={onDragOver}
                      onDrop={(event) => onDropSlot(event, 'debitAmount')}
                      onClick={() => {
                        if (isAnswerChecked) return;
                        if (teuContDebitAmountDrop) {
                          setTeuContDebitAmountDrop(null);
                          setTeuContDebitAmountSourceKey(null);
                        } else {
                          setTeuContAmountTargetSide('D');
                        }
                      }}
                      className={`${renderDropClass(
                        teuContDebitAmountDrop,
                        currentQuestion.correctAmountDebit !== undefined && currentQuestion.correctAmountDebit !== null
                          ? String(currentQuestion.correctAmountDebit)
                          : (currentQuestion.correctSide === 'D'
                            ? String(currentQuestion.correctAmount ?? currentQuestion.amount ?? '')
                            : null)
                      )} ${teuContDebitAmountDrop ? 'teu-cont-drop-zone-filled-cf' : ''} ${teuContAmountTargetSide === 'D' && !teuContDebitAmountDrop && !isAnswerChecked ? 'teu-cont-drop-zone-targeted-cf' : ''}`}
                    >
                      {teuContDebitAmountDrop
                        ? teuContDebitAmountDrop
                        : 'suma in D'}
                    </div>
                  </div>
                  <div className='functional-teu-account-label-cf'></div>
                  <div className='functional-t-side-group-cf teu-cont-side-full-cf'>
                    <div
                      onDragOver={onDragOver}
                      onDrop={(event) => onDropSlot(event, 'creditAmount')}
                      onClick={() => {
                        if (isAnswerChecked) return;
                        if (teuContCreditAmountDrop) {
                          setTeuContCreditAmountDrop(null);
                          setTeuContCreditAmountSourceKey(null);
                        } else {
                          setTeuContAmountTargetSide('C');
                        }
                      }}
                      className={`${renderDropClass(
                        teuContCreditAmountDrop,
                        currentQuestion.correctAmountCredit !== undefined && currentQuestion.correctAmountCredit !== null
                          ? String(currentQuestion.correctAmountCredit)
                          : (currentQuestion.correctSide === 'C'
                            ? String(currentQuestion.correctAmount ?? currentQuestion.amount ?? '')
                            : null)
                      )} ${teuContCreditAmountDrop ? 'teu-cont-drop-zone-filled-cf' : ''} ${teuContAmountTargetSide === 'C' && !teuContCreditAmountDrop && !isAnswerChecked ? 'teu-cont-drop-zone-targeted-cf' : ''}`}
                    >
                      {teuContCreditAmountDrop
                        ? teuContCreditAmountDrop
                        : 'suma in C'}
                    </div>
                  </div>
                </div>
              </div>

              {!isAnswerChecked && (
                <div className='simple-select-buttons-description-cf teu-cont-options-row-cf'>
                    {allTeuContOptions.map((optionItem) => {
                      const isConsumed =
                        optionItem.key === teuContTypeSourceKey ||
                        optionItem.key === teuContAccountSourceKey ||
                        optionItem.key === teuContDebitAmountSourceKey ||
                        optionItem.key === teuContCreditAmountSourceKey;

                      return (
                        <button
                          key={optionItem.key}
                          className={`simple-Button-select-cf teu-cont-option-btn-cf ${isConsumed ? 'teu-cont-option-placeholder-cf' : ''}`}
                          draggable={!isConsumed}
                          onDragStart={(event) => {
                            if (isConsumed) return;
                            event.dataTransfer.setData(
                              'application/json',
                              JSON.stringify({ group: optionItem.group, value: optionItem.value, key: optionItem.key })
                            );
                          }}
                          onClick={() => {
                            if (isConsumed) return;
                            placeOptionInNextAvailableSlot(optionItem);
                          }}
                        >
                          <p>{optionItem.value}</p>
                        </button>
                      );
                    })}
                  </div>
              )}
            </div>
          </div>
        );
      }

      case 'oneAccount':
      case 'twoAccounts': {
        const mode = getFunctionalRulesMode(currentQuestion, questionType);
        const accounts = mode === 'twoAccounts'
          ? (Array.isArray(currentQuestion.accounts) ? currentQuestion.accounts : [])
          : [{ account: currentQuestion.account }];

        return (
          <div className="quiz-content-scroll-cf">
            <div className='functional-rules-shell-cf'>
              {currentQuestion.imageoperation && (
                <div className='functional-rules-image-cf'>
                  {currentQuestion.imageoperation}
                </div>
              )}

              <div
                className='functional-rules-statement-cf'
                dangerouslySetInnerHTML={{ __html: currentQuestion.statement || currentQuestion.context || '' }}
              />

              <div className={`functional-accounts-wrapper-cf ${mode === 'twoAccounts' ? 'twoAccounts' : ''}`}>
                {accounts.map((acc, index) => (
                  <div key={index} className='functional-t-account-cf'>
                    <div className='functional-t-header-cf'>
                      <div className='functional-debit-cf'>D</div>
                      <div className='functional-title-account-cf'>{acc.account || currentQuestion.account}</div>
                      <div className='functional-credit-cf'>C</div>
                    </div>

                    <div className='functional-t-body-cf'>
                      <div className='functional-t-side-group-cf'>
                        {['↑', '↓'].map((symbol) => {
                          const selected =
                            functionalRulesAnswers[index]?.side === 'D' &&
                            functionalRulesAnswers[index]?.variation === symbol;

                          const correct = isAnswerChecked && (
                            mode === 'oneAccount'
                              ? currentQuestion.correctSide === 'D' && currentQuestion.correctVariation === symbol
                              : acc.correctSide === 'D' && acc.correctVariation === symbol
                          );

                          const wrong = isAnswerChecked && selected && !correct;

                          return (
                            <div
                              key={`D-${index}-${symbol}`}
                              className={`functional-t-option-cf ${selected ? 'selected' : ''} ${correct ? 'correct' : ''} ${wrong ? 'incorrect' : ''}`}
                              onClick={() => handleFunctionalRulesSelect(index, 'D', symbol)}
                            >
                              {symbol}
                            </div>
                          );
                        })}
                      </div>

                      <div className='functional-t-account-label-cf'></div>

                      <div className='functional-t-side-group-cf'>
                        {['↑', '↓'].map((symbol) => {
                          const selected =
                            functionalRulesAnswers[index]?.side === 'C' &&
                            functionalRulesAnswers[index]?.variation === symbol;

                          const correct = isAnswerChecked && (
                            mode === 'oneAccount'
                              ? currentQuestion.correctSide === 'C' && currentQuestion.correctVariation === symbol
                              : acc.correctSide === 'C' && acc.correctVariation === symbol
                          );

                          const wrong = isAnswerChecked && selected && !correct;

                          return (
                            <div
                              key={`C-${index}-${symbol}`}
                              className={`functional-t-option-cf ${selected ? 'selected' : ''} ${correct ? 'correct' : ''} ${wrong ? 'incorrect' : ''}`}
                              onClick={() => handleFunctionalRulesSelect(index, 'C', symbol)}
                            >
                              {symbol}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
      }


        
        case 'manualInput':
          return (
            <div className="quiz-content-scroll-cf">
            <div className='explanation-lesoon-container-cf'>
              <h4 className='tittle-sescrition-lesson-cf'><strong>{currentQuestion.question}</strong></h4>
        
              <div className='align-input-items-cf'>
                {currentQuestion.correctAnswer.map((answer, index) => {
                  const isCorrect = Number(userInput[index]) === answer.code; // Verifică dacă răspunsul este corect
                  const inputClass = isAnswerChecked
                    ? isCorrect
                      ? 'answer-input-correct-cf'
                      : 'answer-input-incorrect-cf'
                    : 'answer-input-item-complete-cf';
        
                  return (
                    <div key={index}>
                      <div className='input-item-answer-type-cf'>
                        <input
                          className={inputClass}
                          type="number"
                          maxLength='4'
                          value={userInput[index] || ''}
                          onChange={(e) => { 
                            handleInputChange(index, e.target.value); 
                            setDesableButton(false);
                          }}
                          disabled={isAnswerChecked}
                        />
                        <p className='input-title-element-answer-cf'>{answer.label}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            </div>
          );


          

          case 'dragAndDrop': {
            const areAllFieldsCompletedLocal = () => {
              // Verificăm dacă toate câmpurile au fost completate și sunt corecte
              return currentQuestion.options.every((_, index) => {
                return dataReceived[index] && currentQuestion.correctAnswer.includes(dataReceived[index]);
              });
            };
          
            const handleDragItemClick = (answer) => {
              if (!dataReceived.includes(answer)) {
                toggleItem(answer);
              }
            };
          
            const handleReset = () => {
              setDataReceived([]);
            };
          
            const handleUndo = () => {
              setDataReceived((prev) => {
                const updatedData = [...prev];
                const lastFilledIndex = updatedData.findIndex(item => item === undefined) - 1;
                if (lastFilledIndex >= 0) {
                  updatedData[lastFilledIndex] = undefined;
                } else {
                  updatedData.pop();
                }
                return updatedData;
              });
            };
          
            return (
              <div className="quiz-content-scroll-cf">
              <div className='explanation-lesoon-container-cf'>
                <h4 className='tittle-sescrition-lesson-cf'>
                  <strong>{currentQuestion.question}</strong>
                </h4>
          
                {/* Câmpuri pentru răspunsuri */}
                <div className='cadru-lesson-grag-drop-cf'>
                  {currentQuestion.options.map((option, index) => (
                    <button
                      key={index}
                      className='drag-lesson-answer-cf'
                      disabled={index !== dataReceived.length}
                      onClick={() => dataReceived[index] && toggleItem(dataReceived[index], index)}
                    >
                      <div className='drag-option-cf'>
                        {renderAnswer(index)}
                      </div>
                      <div className='drag-text-cf'>
                        <p>{option.label}</p>
                      </div>
                    </button>
                  ))}
                </div>
          
                {/* Butoanele de răspuns disponibile */}
                <div className='drag-background-options-cf'>
                  {currentQuestion.correctAnswer.map((answer, index) => (
                    <button
                      key={index}
                      className='buttons-drag-options-cf'
                      onClick={() => handleDragItemClick(answer)}
                      disabled={dataReceived.includes(answer)}
                    >
                      <div>{answer}</div>
                    </button>
                  ))}
                </div>
          
             
          
                {/* Butonul de verificare */}
                <div className={`position-button-lesson-cf ${hideActionButton ? 'hide-cf hide-border-top-cf' : ''}`}>

              

                  <button
                    className={`button-next-quiz-cf ${areAllFieldsCompletedLocal() ? '' : 'button-next-quiz-desabled-cf'}`}
                    onClick={verifyAnswer}
                    disabled={!areAllFieldsCompletedLocal()}
                  >
                    Verifică
                  </button>
                </div>
              </div>
              </div>
            );
          }
       case 'dragAndDropHorizontal': {
  const areAllFieldsCompletedLocal = () => dataReceived.every(v => v !== null && v !== undefined);

  const handleDragItemClick = (code) => {
    if (isAnswerChecked) return;
    if (dataReceived.includes(code)) return;

    const emptyIndex = dataReceived.findIndex(
      v => v === null || v === undefined
    );

    if (emptyIndex !== -1) {
      setDataReceived(prev => {
        const updated = [...prev];
        updated[emptyIndex] = code;
        return updated;
      });
    }
  };

  const handleBoxClick = (slotIndex) => {
    if (isAnswerChecked) return;

    setDataReceived(prev => {
      const updated = [...prev];
      updated[slotIndex] = null;
      return updated;
    });
  };

  let slotCounter = -1;

  return (
    <div className="quiz-content-scroll-cf">
    <div className='explanation-lesoon-container-cf'>
      <div className='title-simple-select-align-cf'>
        <p className='centred-simple-element-cf'>{currentQuestion.question}</p>
      </div>

      <div className='horizontal-equation-layout-cf'>
        {currentQuestion.correctAnswer.map((chunk, i) => {
          const isBlank = i % 2 === 1; // blank la indecsi impari: 1,3,5...

          if (!isBlank) {
            return <span key={`txt-${i}`} className='equation-static-chunk-cf'>{chunk} </span>;
          }

          slotCounter += 1;
          const slotIndex = slotCounter;
          const value = dataReceived[slotIndex] || '';

          return (
            <span
              key={`box-${slotIndex}`}
              className={`equation-box-cf ${isAnswerChecked ? '' : 'cursor-pointer-cf'}`}
              onClick={() => handleBoxClick(slotIndex)}
            >
              {value}
            </span>
          );
        })}
      </div>

      {!isAnswerChecked && (
        <div className='horizontal-options-cf horizontal-options-bottom-cf'>
          {(shuffledDragHorizontalOptions.length ? shuffledDragHorizontalOptions : currentQuestion.options).map((option) => {
            const isUsed = dataReceived.includes(option.code);

            return (
              <button
                key={option.code}
                className={`equation-option-btn-cf ${isUsed ? 'option-used-outline-cf' : ''}`}
                onClick={() => handleDragItemClick(option.code)}
              >
                {option.code}
              </button>
            );
          })}
        </div>
      )}



      <div className='position-button-lesson-cf'>
        <button
          className={`button-next-quiz-cf ${areAllFieldsCompletedLocal() ? '' : 'button-next-quiz-desabled-cf'}`}
          onClick={verifyAnswer}
          disabled={!areAllFieldsCompletedLocal()}
        >
          Verifica
        </button>
      </div>
    </div>
    </div>
  );
}

          case 'dragAndDropOneAnswer': {
            const areAllFieldsCompletedLocal = () => {
              return dataReceived.length === 1 && dataReceived[0] !== null && dataReceived[0] !== undefined;
            };
          
            const handleDragItemClick = (code) => {
              if (!isAnswerChecked && !dataReceived.includes(code)) {
                setDataReceived([code]);
              }
            };
          
            const handleBoxClick = () => {
              if (!isAnswerChecked) {
                setDataReceived([]);
              }
            };
          
            return (
              <div className="quiz-content-scroll-cf">
              <div className='explanation-lesoon-container-cf'>
                <div className='title-simple-select-align-cf'>
                
                  <div className="centred-simple-element-cf">
                    <span className="question-text-cf">{currentQuestion.question}</span>
                 
                  </div>


                  
                </div>
          
                {/* Propoziția completabilă */}
<div className="horizontal-equation-layout-cf">
  <span className="equation-box-static-cf">
    {currentQuestion.correctAnswer[0]}{" "}
    <span
      className={`equation-box-cf ${isAnswerChecked ? '' : 'cursor-pointer-cf'}`}
      onClick={handleBoxClick}
    >
      {dataReceived[0] || ''}
    </span>{" "}
    {currentQuestion.correctAnswer[2]}
  </span>
</div>



          
                {/* Zona cu opțiuni + buton jos */}
                  {!isAnswerChecked && (
                    <div className='horizontal-options-cf'>
                      {currentQuestion.options.map((option, index) => {
                        const isUsed = dataReceived.includes(option.code);
                        return (
                          <button
                            key={index}
                            className={`equation-option-btn-cf ${isUsed ? 'placeholder-btn-cf' : ''}`}
                            onClick={() => handleDragItemClick(option.code)}
                            disabled={isUsed}
                          >
                            {option.code}
                          </button>
                        );
                      })}
                    </div>
                  )}
                <div className='position-button-lesson-cf'>
                
          
                  {/* Buton Verifică */}
                  <button
                    className={`button-next-quiz-cf ${areAllFieldsCompletedLocal() ? '' : 'button-next-quiz-desabled-cf'}`}
                    onClick={verifyAnswer}
                    disabled={!areAllFieldsCompletedLocal()}
                  >
                    Verifică
                  </button>
                </div>
              </div>
              </div>
            );
          }

          case 'sipleFormula': {
            const normalizedOptions = (shuffledSipleFormulaOptions.length
              ? shuffledSipleFormulaOptions
              : (currentQuestion.options || [])
            ).map((option, index) => {
              if (option && typeof option === 'object') {
                const value = option.code ?? option.value ?? option.label ?? '';
                const label = option.label ?? option.code ?? option.value ?? '';
                return {
                  id: option.id ?? `${String(value)}-${index}`,
                  value: String(value),
                  label: String(label),
                };
              }

              return {
                id: `${String(option)}-${index}`,
                value: String(option),
                label: String(option),
              };
            });

            const slotsCount = Array.isArray(currentQuestion.correctAnswer) && currentQuestion.correctAnswer.length > 0
              ? currentQuestion.correctAnswer.length
              : 4;

            const slotLabels = Array.isArray(currentQuestion.slotLabels) && currentQuestion.slotLabels.length === slotsCount
              ? currentQuestion.slotLabels
              : Array.from({ length: slotsCount }, (_, idx) => `Camp ${idx + 1}`);

            const onDragStartOption = (event, value) => {
              if (isAnswerChecked) return;
              event.dataTransfer.setData('text/plain', String(value));
              event.dataTransfer.effectAllowed = 'move';
            };

            const onDragOver = (event) => {
              event.preventDefault();
            };

            const placeInSlot = (slotIndex, value) => {
              if (isAnswerChecked) return;
              if (value === null || value === undefined || value === '') return;

              setDataReceived((prev) => {
                const next = Array.isArray(prev) && prev.length === slotsCount
                  ? [...prev]
                  : Array(slotsCount).fill(null);

                const existingIndex = next.findIndex((item) => item === String(value));
                if (existingIndex !== -1 && existingIndex !== slotIndex) {
                  next[existingIndex] = null;
                }

                next[slotIndex] = String(value);
                return next;
              });

              setTextButton('Verifica');
              setChangeColorButton(true);
            };

            const onDropOnSlot = (event, slotIndex) => {
              event.preventDefault();
              if (isAnswerChecked) return;

              const value = event.dataTransfer.getData('text/plain');
              placeInSlot(slotIndex, value);
            };

            const onDropOnOptionsArea = (event) => {
              event.preventDefault();
              if (isAnswerChecked) return;

              const value = event.dataTransfer.getData('text/plain');
              if (!value) return;

              setDataReceived((prev) => prev.map((item) => (item === value ? null : item)));
            };

            const onSlotClick = (slotIndex) => {
              if (isAnswerChecked) return;
              setDataReceived((prev) => {
                const next = [...prev];
                next[slotIndex] = null;
                return next;
              });
            };

            const onOptionClick = (value) => {
              if (isAnswerChecked) return;
              if (dataReceived.includes(String(value))) return;

              const firstEmpty = dataReceived.findIndex(
                (item) => item === null || item === undefined
              );

              if (firstEmpty === -1) return;
              placeInSlot(firstEmpty, value);
            };

            const onDragStartSlot = (event, value) => {
              if (isAnswerChecked || !value) return;
              event.dataTransfer.setData('text/plain', String(value));
              event.dataTransfer.effectAllowed = 'move';
            };

            const expectedAnswers = Array.isArray(currentQuestion.correctAnswer)
              ? currentQuestion.correctAnswer.map((item) => String(item))
              : [];

            return (
              <div className="quiz-content-scroll-cf">
                <div className='explanation-lesoon-container-cf siple-formula-shell-cf'>
                  <div className='title-simple-select-align-cf siple-formula-title-wrap-cf'>
                    <p className='question-text-cf siple-formula-question-cf'>{currentQuestion.question}</p>
                  </div>

                  <div className='siple-formula-slots-cf'>
                    {Array.from({ length: slotsCount }).map((_, slotIndex) => {
                      const value = dataReceived[slotIndex] || '';
                      const expected = expectedAnswers[slotIndex] || '';
                      const isCorrectSlot = isAnswerChecked && value && value === expected;
                      const isWrongSlot = isAnswerChecked && value && value !== expected;

                      return (
                        <button
                          key={`slot-${slotIndex}`}
                          type="button"
                          className={`siple-formula-slot-cf ${value ? 'filled' : ''} ${
                            isCorrectSlot ? 'correct' : ''
                          } ${isWrongSlot ? 'incorrect' : ''}`}
                          onDragOver={onDragOver}
                          onDrop={(event) => onDropOnSlot(event, slotIndex)}
                          onClick={() => onSlotClick(slotIndex)}
                          draggable={!isAnswerChecked && Boolean(value)}
                          onDragStart={(event) => onDragStartSlot(event, value)}
                          disabled={isAnswerChecked}
                        >
                          <span className='siple-formula-slot-label-cf'></span>
                          <span className='siple-formula-slot-value-cf'>{value}</span>
                        </button>
                      );
                    })}
                  </div>

                  {!isAnswerChecked && (
                    <div
                      className='siple-formula-options-cf'
                      onDragOver={onDragOver}
                      onDrop={onDropOnOptionsArea}
                    >
                      {normalizedOptions.map((option) => {
                          const isUsed = dataReceived.includes(option.value);
                          return (
                            <button
                              key={option.id}
                              type="button"
                              className={`siple-formula-option-cf ${isUsed ? 'used' : ''}`}
                              draggable={!isUsed}
                              onDragStart={(event) => !isUsed && onDragStartOption(event, option.value)}
                              onClick={() => !isUsed && onOptionClick(option.value)}
                              disabled={isUsed}
                            >
                              {!isUsed && option.label}
                            </button>
                          );
                        })}
                    </div>
                  )}

                  <div className='position-button-lesson-cf'>
                    <button
                      className={`button-next-quiz-cf ${areAllFieldsCompleted() ? '' : 'button-next-quiz-desabled-cf'}`}
                      onClick={verifyAnswer}
                      disabled={!areAllFieldsCompleted()}
                    >
                      Verifica
                    </button>
                  </div>
                </div>
              </div>
            );
          }

          case 'multipleFormulaLeft': {
            const mflNormalizedOptions = (shuffledMultipleFormulaLeftOptions.length
              ? shuffledMultipleFormulaLeftOptions
              : (currentQuestion.options || [])
            ).map((option, index) => {
              if (option && typeof option === 'object') {
                const value = option.code ?? option.value ?? option.label ?? '';
                const label = option.label ?? option.code ?? option.value ?? '';
                return { id: option.id ?? `${String(value)}-${index}`, value: String(value), label: String(label) };
              }
              return { id: `${String(option)}-${index}`, value: String(option), label: String(option) };
            });

            const mflSlotsCount = Array.isArray(currentQuestion.correctAnswer) && currentQuestion.correctAnswer.length > 0
              ? currentQuestion.correctAnswer.length
              : 8;

            const mflTopCount   = currentQuestion.topRowCount   ?? 4;
            const mflLeftCount  = currentQuestion.leftColCount  ?? Math.floor((mflSlotsCount - mflTopCount) / 2);
            const mflRightCount = mflSlotsCount - mflTopCount - mflLeftCount;

            const mflExpected = Array.isArray(currentQuestion.correctAnswer)
              ? currentQuestion.correctAnswer.map((item) => String(item))
              : [];

            const mflOnDragOver = (event) => event.preventDefault();

            const mflDragStartOption = (event, value) => {
              if (isAnswerChecked) return;
              event.dataTransfer.setData('text/plain', String(value));
              event.dataTransfer.effectAllowed = 'move';
            };

            const mflPlaceInSlot = (slotIndex, value) => {
              if (isAnswerChecked || value === null || value === undefined || value === '') return;
              setDataReceived((prev) => {
                const next = Array.isArray(prev) && prev.length === mflSlotsCount
                  ? [...prev]
                  : Array(mflSlotsCount).fill(null);
                const existingIndex = next.findIndex((item) => item === String(value));
                if (existingIndex !== -1 && existingIndex !== slotIndex) next[existingIndex] = null;
                next[slotIndex] = String(value);
                return next;
              });
              setTextButton('Verifica');
              setChangeColorButton(true);
            };

            const mflDropOnSlot = (event, slotIndex) => {
              event.preventDefault();
              if (isAnswerChecked) return;
              mflPlaceInSlot(slotIndex, event.dataTransfer.getData('text/plain'));
            };

            const mflDropOnOptions = (event) => {
              event.preventDefault();
              if (isAnswerChecked) return;
              const value = event.dataTransfer.getData('text/plain');
              if (value) setDataReceived((prev) => prev.map((item) => (item === value ? null : item)));
            };

            const mflSlotClick = (slotIndex) => {
              if (isAnswerChecked) return;
              setDataReceived((prev) => { const n = [...prev]; n[slotIndex] = null; return n; });
            };

            const mflOptionClick = (value) => {
              if (isAnswerChecked || dataReceived.includes(String(value))) return;
              const firstEmpty = dataReceived.findIndex((item) => item === null || item === undefined);
              if (firstEmpty !== -1) mflPlaceInSlot(firstEmpty, value);
            };

            const mflDragStartSlot = (event, value) => {
              if (isAnswerChecked || !value) return;
              event.dataTransfer.setData('text/plain', String(value));
              event.dataTransfer.effectAllowed = 'move';
            };

            const renderMflSlot = (slotIndex) => {
              const value = dataReceived[slotIndex] || '';
              const expected = mflExpected[slotIndex] || '';
              const isCorrectSlot = isAnswerChecked && value && value === expected;
              const isWrongSlot   = isAnswerChecked && value && value !== expected;
              return (
                <button
                  key={`mfl-slot-${slotIndex}`}
                  type="button"
                  className={`mfl-slot-cf ${value ? 'filled' : ''} ${isCorrectSlot ? 'correct' : ''} ${isWrongSlot ? 'incorrect' : ''}`}
                  onDragOver={mflOnDragOver}
                  onDrop={(e) => mflDropOnSlot(e, slotIndex)}
                  onClick={() => mflSlotClick(slotIndex)}
                  draggable={!isAnswerChecked && Boolean(value)}
                  onDragStart={(e) => mflDragStartSlot(e, value)}
                  disabled={isAnswerChecked}
                >
                  <span className='mfl-slot-value-cf'>{value}</span>
                </button>
              );
            };

            return (
              <div className="quiz-content-scroll-cf">
                <div className='explanation-lesoon-container-cf mfl-shell-cf'>
                  <div className='title-simple-select-align-cf siple-formula-title-wrap-cf'>
                    <p className='question-text-cf siple-formula-question-cf'>{currentQuestion.question}</p>
                  </div>

                  {/* Rândul de sus */}
                  <div className='mfl-top-row-cf'>
                    {Array.from({ length: mflTopCount }, (_, i) => renderMflSlot(i))}
                  </div>

                  {/* Secțiunea de mijloc: coloana stângă + spațiu + coloana dreaptă */}
                  <div className='mfl-middle-section-cf'>
                    <div className='mfl-col-cf'>
                      {Array.from({ length: mflLeftCount }, (_, i) => renderMflSlot(mflTopCount + i))}
                    </div>
                    <div className='mfl-col-spacer-cf' />
                    <div className='mfl-col-cf'>
                      {Array.from({ length: mflRightCount }, (_, i) => renderMflSlot(mflTopCount + mflLeftCount + i))}
                    </div>
                  </div>

                  {/* Opțiuni */}
                  {!isAnswerChecked && (
                    <div
                      className='mfl-options-cf'
                      onDragOver={mflOnDragOver}
                      onDrop={mflDropOnOptions}
                    >
                      {mflNormalizedOptions.map((option) => {
                        const isUsed = dataReceived.includes(option.value);
                        return (
                          <button
                            key={option.id}
                            type="button"
                            className={`mfl-option-cf ${isUsed ? 'used' : ''}`}
                            draggable={!isUsed}
                            onDragStart={(e) => !isUsed && mflDragStartOption(e, option.value)}
                            onClick={() => !isUsed && mflOptionClick(option.value)}
                            disabled={isUsed}
                          >
                            {!isUsed && option.label}
                          </button>
                        );
                      })}
                    </div>
                  )}

                  <div className='position-button-lesson-cf'>
                    <button
                      className={`button-next-quiz-cf ${areAllFieldsCompleted() ? '' : 'button-next-quiz-desabled-cf'}`}
                      onClick={verifyAnswer}
                      disabled={!areAllFieldsCompleted()}
                    >
                      Verifica
                    </button>
                  </div>
                </div>
              </div>
            );
          }

          case 'multipleFormulaRight': {
            const mfrNormalizedOptions = (shuffledMultipleFormulaRightOptions.length
              ? shuffledMultipleFormulaRightOptions
              : (currentQuestion.options || [])
            ).map((option, index) => {
              if (option && typeof option === 'object') {
                const value = option.code ?? option.value ?? option.label ?? '';
                const label = option.label ?? option.code ?? option.value ?? '';
                return { id: option.id ?? `${String(value)}-${index}`, value: String(value), label: String(label) };
              }
              return { id: `${String(option)}-${index}`, value: String(option), label: String(option) };
            });

            const mfrSlotsCount = Array.isArray(currentQuestion.correctAnswer) && currentQuestion.correctAnswer.length > 0
              ? currentQuestion.correctAnswer.length
              : 8;

            const mfrTopCount = currentQuestion.topRowCount ?? 4;
            const mfrMidLeftCount = currentQuestion.rightInnerColCount ?? Math.floor((mfrSlotsCount - mfrTopCount) / 2);
            const mfrMidRightCount = mfrSlotsCount - mfrTopCount - mfrMidLeftCount;

            const mfrExpected = Array.isArray(currentQuestion.correctAnswer)
              ? currentQuestion.correctAnswer.map((item) => String(item))
              : [];

            const mfrOnDragOver = (event) => event.preventDefault();

            const mfrDragStartOption = (event, value) => {
              if (isAnswerChecked) return;
              event.dataTransfer.setData('text/plain', String(value));
              event.dataTransfer.effectAllowed = 'move';
            };

            const mfrPlaceInSlot = (slotIndex, value) => {
              if (isAnswerChecked || value === null || value === undefined || value === '') return;
              setDataReceived((prev) => {
                const next = Array.isArray(prev) && prev.length === mfrSlotsCount
                  ? [...prev]
                  : Array(mfrSlotsCount).fill(null);
                const existingIndex = next.findIndex((item) => item === String(value));
                if (existingIndex !== -1 && existingIndex !== slotIndex) next[existingIndex] = null;
                next[slotIndex] = String(value);
                return next;
              });
              setTextButton('Verifica');
              setChangeColorButton(true);
            };

            const mfrDropOnSlot = (event, slotIndex) => {
              event.preventDefault();
              if (isAnswerChecked) return;
              mfrPlaceInSlot(slotIndex, event.dataTransfer.getData('text/plain'));
            };

            const mfrDropOnOptions = (event) => {
              event.preventDefault();
              if (isAnswerChecked) return;
              const value = event.dataTransfer.getData('text/plain');
              if (value) setDataReceived((prev) => prev.map((item) => (item === value ? null : item)));
            };

            const mfrSlotClick = (slotIndex) => {
              if (isAnswerChecked) return;
              setDataReceived((prev) => { const n = [...prev]; n[slotIndex] = null; return n; });
            };

            const mfrOptionClick = (value) => {
              if (isAnswerChecked || dataReceived.includes(String(value))) return;
              const firstEmpty = dataReceived.findIndex((item) => item === null || item === undefined);
              if (firstEmpty !== -1) mfrPlaceInSlot(firstEmpty, value);
            };

            const mfrDragStartSlot = (event, value) => {
              if (isAnswerChecked || !value) return;
              event.dataTransfer.setData('text/plain', String(value));
              event.dataTransfer.effectAllowed = 'move';
            };

            const renderMfrSlot = (slotIndex) => {
              const value = dataReceived[slotIndex] || '';
              const expected = mfrExpected[slotIndex] || '';
              const isCorrectSlot = isAnswerChecked && value && value === expected;
              const isWrongSlot = isAnswerChecked && value && value !== expected;
              return (
                <button
                  key={`mfr-slot-${slotIndex}`}
                  type="button"
                  className={`mfr-slot-cf ${value ? 'filled' : ''} ${isCorrectSlot ? 'correct' : ''} ${isWrongSlot ? 'incorrect' : ''}`}
                  onDragOver={mfrOnDragOver}
                  onDrop={(e) => mfrDropOnSlot(e, slotIndex)}
                  onClick={() => mfrSlotClick(slotIndex)}
                  draggable={!isAnswerChecked && Boolean(value)}
                  onDragStart={(e) => mfrDragStartSlot(e, value)}
                  disabled={isAnswerChecked}
                >
                  <span className='mfr-slot-value-cf'>{value}</span>
                </button>
              );
            };

            return (
              <div className="quiz-content-scroll-cf">
                <div className='explanation-lesoon-container-cf mfr-shell-cf'>
                  <div className='title-simple-select-align-cf siple-formula-title-wrap-cf'>
                    <p className='question-text-cf siple-formula-question-cf'>{currentQuestion.question}</p>
                  </div>

                  <div className='mfr-top-row-cf'>
                    {Array.from({ length: mfrTopCount }, (_, i) => renderMfrSlot(i))}
                  </div>

                  <div className='mfr-middle-section-cf'>
                    <div className='mfr-col-spacer-cf' />
                    <div className='mfr-col-cf'>
                      {Array.from({ length: mfrMidLeftCount }, (_, i) => renderMfrSlot(mfrTopCount + i))}
                    </div>
                    <div className='mfr-col-cf'>
                      {Array.from({ length: mfrMidRightCount }, (_, i) => renderMfrSlot(mfrTopCount + mfrMidLeftCount + i))}
                    </div>
                  </div>

                  {!isAnswerChecked && (
                    <div
                      className='mfr-options-cf'
                      onDragOver={mfrOnDragOver}
                      onDrop={mfrDropOnOptions}
                    >
                      {mfrNormalizedOptions.map((option) => {
                        const isUsed = dataReceived.includes(option.value);
                        return (
                          <button
                            key={option.id}
                            type="button"
                            className={`mfr-option-cf ${isUsed ? 'used' : ''}`}
                            draggable={!isUsed}
                            onDragStart={(e) => !isUsed && mfrDragStartOption(e, option.value)}
                            onClick={() => !isUsed && mfrOptionClick(option.value)}
                            disabled={isUsed}
                          >
                            {!isUsed && option.label}
                          </button>
                        );
                      })}
                    </div>
                  )}

                  <div className='position-button-lesson-cf'>
                    <button
                      className={`button-next-quiz-cf ${areAllFieldsCompleted() ? '' : 'button-next-quiz-desabled-cf'}`}
                      onClick={verifyAnswer}
                      disabled={!areAllFieldsCompleted()}
                    >
                      Verifica
                    </button>
                  </div>
                </div>
              </div>
            );
          }

      case 'decisionFlowApplication': {
        const step = currentQuestion?.steps?.[decisionStepIndex];

        if (decisionPhase === 'intro') {
          return (
            <div className="quiz-content-scroll-cf">
              <div className='explanation-lesoon-container-cf'>
                <div className='type-account-quiz-shell-cf'>
                 
                  <div className='horizontal-equation-layout-cf'>
                    <p className='equation-box-static-cf equation-box-static-preline-cf'>
                      {currentQuestion.context}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        }

        if (decisionPhase === 'final') {
          return (
            <div className="quiz-content-scroll-cf">
              <div className='explanation-lesoon-container-cf'>
                <div className='type-account-quiz-shell-cf'>
                  <h3 className='type-account-title-cf'>Aplicatie finalizata</h3>
                  <div
                    className='horizontal-equation-layout-cf'
                    dangerouslySetInnerHTML={{
                      __html: currentQuestion.finalMessage || '<p>Aplicatie finalizata cu succes.</p>'
                    }}
                  />
                </div>
              </div>
            </div>
          );
        }

        if (!step) {
          return null;
        }

        return (
          <div className="quiz-content-scroll-cf">
            <div className='explanation-lesoon-container-cf'>
              <div className='title-simple-select-align-cf'>
                <p className='practice-steps-cf'>{decisionStepIndex + 1} / {currentQuestion.steps.length}</p>
              </div>

              <div className='horizontal-equation-layout-cf'>
                <p className='equation-box-static-cf'>{step.question}</p>
              </div>

              {step.type === 'decizionMultipleFormulaLeft' ? (
                (() => {
                  const dmflNormalizedOptions = (shuffledDecisionMflOptions.length
                    ? shuffledDecisionMflOptions
                    : (step.options || [])
                  ).map((option, index) => {
                    if (option && typeof option === 'object') {
                      const value = option.code ?? option.value ?? option.label ?? '';
                      const label = option.label ?? option.code ?? option.value ?? '';
                      return { id: option.id ?? `dmfl-${String(value)}-${index}`, value: String(value), label: String(label) };
                    }
                    return { id: `dmfl-${String(option)}-${index}`, value: String(option), label: String(option) };
                  });

                  const dmflSlotsCount = Array.isArray(step.correctAnswer) && step.correctAnswer.length > 0
                    ? step.correctAnswer.length
                    : 8;

                  const dmflTopCount   = step.topRowCount  ?? 4;
                  const dmflLeftCount  = step.leftColCount ?? Math.floor((dmflSlotsCount - dmflTopCount) / 2);
                  const dmflRightCount = dmflSlotsCount - dmflTopCount - dmflLeftCount;

                  const dmflExpected = Array.isArray(step.correctAnswer)
                    ? step.correctAnswer.map((item) => String(item))
                    : [];

                  const dmflOnDragOver = (event) => event.preventDefault();

                  const dmflDragStartOption = (event, value) => {
                    if (isAnswerChecked) return;
                    event.dataTransfer.setData('text/plain', String(value));
                    event.dataTransfer.effectAllowed = 'move';
                  };

                  const dmflPlaceInSlot = (slotIndex, value) => {
                    if (isAnswerChecked || value === null || value === undefined || value === '') return;
                    setDecisionMflData((prev) => {
                      const next = Array.isArray(prev) && prev.length === dmflSlotsCount
                        ? [...prev]
                        : Array(dmflSlotsCount).fill(null);
                      const existingIndex = next.findIndex((item) => item === String(value));
                      if (existingIndex !== -1 && existingIndex !== slotIndex) next[existingIndex] = null;
                      next[slotIndex] = String(value);
                      return next;
                    });
                    setTextButton('Verifica');
                    setChangeColorButton(true);
                  };

                  const dmflDropOnSlot = (event, slotIndex) => {
                    event.preventDefault();
                    if (isAnswerChecked) return;
                    dmflPlaceInSlot(slotIndex, event.dataTransfer.getData('text/plain'));
                  };

                  const dmflDropOnOptions = (event) => {
                    event.preventDefault();
                    if (isAnswerChecked) return;
                    const value = event.dataTransfer.getData('text/plain');
                    if (value) setDecisionMflData((prev) => prev.map((item) => (item === value ? null : item)));
                  };

                  const dmflSlotClick = (slotIndex) => {
                    if (isAnswerChecked) return;
                    setDecisionMflData((prev) => { const n = [...prev]; n[slotIndex] = null; return n; });
                  };

                  const dmflOptionClick = (value) => {
                    if (isAnswerChecked || decisionMflData.includes(String(value))) return;
                    const firstEmpty = decisionMflData.findIndex((item) => item === null || item === undefined);
                    if (firstEmpty !== -1) dmflPlaceInSlot(firstEmpty, value);
                  };

                  const dmflDragStartSlot = (event, value) => {
                    if (isAnswerChecked || !value) return;
                    event.dataTransfer.setData('text/plain', String(value));
                    event.dataTransfer.effectAllowed = 'move';
                  };

                  const renderDmflSlot = (slotIndex) => {
                    const value = decisionMflData[slotIndex] || '';
                    const expected = dmflExpected[slotIndex] || '';
                    const isCorrectSlot = isAnswerChecked && value && value === expected;
                    const isWrongSlot   = isAnswerChecked && value && value !== expected;
                    return (
                      <button
                        key={`dmfl-slot-${slotIndex}`}
                        type="button"
                        className={`mfl-slot-cf ${value ? 'filled' : ''} ${isCorrectSlot ? 'correct' : ''} ${isWrongSlot ? 'incorrect' : ''}`}
                        onDragOver={dmflOnDragOver}
                        onDrop={(e) => dmflDropOnSlot(e, slotIndex)}
                        onClick={() => dmflSlotClick(slotIndex)}
                        draggable={!isAnswerChecked && Boolean(value)}
                        onDragStart={(e) => dmflDragStartSlot(e, value)}
                        disabled={isAnswerChecked}
                      >
                        <span className='mfl-slot-value-cf'>{value}</span>
                      </button>
                    );
                  };

                  return (
                    <>
                      <div className='mfl-top-row-cf'>
                        {Array.from({ length: dmflTopCount }, (_, i) => renderDmflSlot(i))}
                      </div>

                      <div className='mfl-middle-section-cf'>
                        <div className='mfl-col-cf'>
                          {Array.from({ length: dmflLeftCount }, (_, i) => renderDmflSlot(dmflTopCount + i))}
                        </div>
                        <div className='mfl-col-spacer-cf' />
                        <div className='mfl-col-cf'>
                          {Array.from({ length: dmflRightCount }, (_, i) => renderDmflSlot(dmflTopCount + dmflLeftCount + i))}
                        </div>
                      </div>

                      {!isAnswerChecked && (
                        <div
                          className='mfl-options-cf'
                          onDragOver={dmflOnDragOver}
                          onDrop={dmflDropOnOptions}
                        >
                          {dmflNormalizedOptions.map((option) => {
                            const isUsed = decisionMflData.includes(option.value);
                            return (
                              <button
                                key={option.id}
                                type="button"
                                className={`mfl-option-cf ${isUsed ? 'used' : ''}`}
                                draggable={!isUsed}
                                onDragStart={(e) => !isUsed && dmflDragStartOption(e, option.value)}
                                onClick={() => !isUsed && dmflOptionClick(option.value)}
                                disabled={isUsed}
                              >
                                {!isUsed && option.label}
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </>
                  );
                })()
              ) : step.type === 'decizionMultipleFormulaRight' ? (
                (() => {
                  const dmfrNormalizedOptions = (shuffledDecisionMfrOptions.length
                    ? shuffledDecisionMfrOptions
                    : (step.options || [])
                  ).map((option, index) => {
                    if (option && typeof option === 'object') {
                      const value = option.code ?? option.value ?? option.label ?? '';
                      const label = option.label ?? option.code ?? option.value ?? '';
                      return { id: option.id ?? `dmfr-${String(value)}-${index}`, value: String(value), label: String(label) };
                    }
                    return { id: `dmfr-${String(option)}-${index}`, value: String(option), label: String(option) };
                  });

                  const dmfrSlotsCount = Array.isArray(step.correctAnswer) && step.correctAnswer.length > 0
                    ? step.correctAnswer.length
                    : 8;

                  const dmfrTopCount = step.topRowCount ?? 4;
                  const dmfrMidLeftCount = step.rightInnerColCount ?? Math.floor((dmfrSlotsCount - dmfrTopCount) / 2);
                  const dmfrMidRightCount = dmfrSlotsCount - dmfrTopCount - dmfrMidLeftCount;

                  const dmfrExpected = Array.isArray(step.correctAnswer)
                    ? step.correctAnswer.map((item) => String(item))
                    : [];

                  const dmfrOnDragOver = (event) => event.preventDefault();

                  const dmfrDragStartOption = (event, value) => {
                    if (isAnswerChecked) return;
                    event.dataTransfer.setData('text/plain', String(value));
                    event.dataTransfer.effectAllowed = 'move';
                  };

                  const dmfrPlaceInSlot = (slotIndex, value) => {
                    if (isAnswerChecked || value === null || value === undefined || value === '') return;
                    setDecisionMfrData((prev) => {
                      const next = Array.isArray(prev) && prev.length === dmfrSlotsCount
                        ? [...prev]
                        : Array(dmfrSlotsCount).fill(null);
                      const existingIndex = next.findIndex((item) => item === String(value));
                      if (existingIndex !== -1 && existingIndex !== slotIndex) next[existingIndex] = null;
                      next[slotIndex] = String(value);
                      return next;
                    });
                    setTextButton('Verifica');
                    setChangeColorButton(true);
                  };

                  const dmfrDropOnSlot = (event, slotIndex) => {
                    event.preventDefault();
                    if (isAnswerChecked) return;
                    dmfrPlaceInSlot(slotIndex, event.dataTransfer.getData('text/plain'));
                  };

                  const dmfrDropOnOptions = (event) => {
                    event.preventDefault();
                    if (isAnswerChecked) return;
                    const value = event.dataTransfer.getData('text/plain');
                    if (value) setDecisionMfrData((prev) => prev.map((item) => (item === value ? null : item)));
                  };

                  const dmfrSlotClick = (slotIndex) => {
                    if (isAnswerChecked) return;
                    setDecisionMfrData((prev) => { const n = [...prev]; n[slotIndex] = null; return n; });
                  };

                  const dmfrOptionClick = (value) => {
                    if (isAnswerChecked || decisionMfrData.includes(String(value))) return;
                    const firstEmpty = decisionMfrData.findIndex((item) => item === null || item === undefined);
                    if (firstEmpty !== -1) dmfrPlaceInSlot(firstEmpty, value);
                  };

                  const dmfrDragStartSlot = (event, value) => {
                    if (isAnswerChecked || !value) return;
                    event.dataTransfer.setData('text/plain', String(value));
                    event.dataTransfer.effectAllowed = 'move';
                  };

                  const renderDmfrSlot = (slotIndex) => {
                    const value = decisionMfrData[slotIndex] || '';
                    const expected = dmfrExpected[slotIndex] || '';
                    const isCorrectSlot = isAnswerChecked && value && value === expected;
                    const isWrongSlot = isAnswerChecked && value && value !== expected;
                    return (
                      <button
                        key={`dmfr-slot-${slotIndex}`}
                        type="button"
                        className={`mfr-slot-cf ${value ? 'filled' : ''} ${isCorrectSlot ? 'correct' : ''} ${isWrongSlot ? 'incorrect' : ''}`}
                        onDragOver={dmfrOnDragOver}
                        onDrop={(e) => dmfrDropOnSlot(e, slotIndex)}
                        onClick={() => dmfrSlotClick(slotIndex)}
                        draggable={!isAnswerChecked && Boolean(value)}
                        onDragStart={(e) => dmfrDragStartSlot(e, value)}
                        disabled={isAnswerChecked}
                      >
                        <span className='mfr-slot-value-cf'>{value}</span>
                      </button>
                    );
                  };

                  return (
                    <>
                      <div className='mfr-top-row-cf'>
                        {Array.from({ length: dmfrTopCount }, (_, i) => renderDmfrSlot(i))}
                      </div>

                      <div className='mfr-middle-section-cf'>
                        <div className='mfr-col-spacer-cf' />
                        <div className='mfr-col-cf'>
                          {Array.from({ length: dmfrMidLeftCount }, (_, i) => renderDmfrSlot(dmfrTopCount + i))}
                        </div>
                        <div className='mfr-col-cf'>
                          {Array.from({ length: dmfrMidRightCount }, (_, i) => renderDmfrSlot(dmfrTopCount + dmfrMidLeftCount + i))}
                        </div>
                      </div>

                      {!isAnswerChecked && (
                        <div
                          className='mfr-options-cf'
                          onDragOver={dmfrOnDragOver}
                          onDrop={dmfrDropOnOptions}
                        >
                          {dmfrNormalizedOptions.map((option) => {
                            const isUsed = decisionMfrData.includes(option.value);
                            return (
                              <button
                                key={option.id}
                                type="button"
                                className={`mfr-option-cf ${isUsed ? 'used' : ''}`}
                                draggable={!isUsed}
                                onDragStart={(e) => !isUsed && dmfrDragStartOption(e, option.value)}
                                onClick={() => !isUsed && dmfrOptionClick(option.value)}
                                disabled={isUsed}
                              >
                                {!isUsed && option.label}
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </>
                  );
                })()
              ) : step.type === 'decizionSipleFormula' ? (
                (() => {
                  const sfNormalizedOptions = (shuffledDecisionSipleFormulaOptions.length
                    ? shuffledDecisionSipleFormulaOptions
                    : (step.options || [])
                  ).map((option, index) => {
                    if (option && typeof option === 'object') {
                      const value = option.code ?? option.value ?? option.label ?? '';
                      const label = option.label ?? option.code ?? option.value ?? '';
                      return { id: option.id ?? `dsf-${String(value)}-${index}`, value: String(value), label: String(label) };
                    }
                    return { id: `dsf-${String(option)}-${index}`, value: String(option), label: String(option) };
                  });

                  const sfSlotsCount = Array.isArray(step.correctAnswer) && step.correctAnswer.length > 0
                    ? step.correctAnswer.length
                    : 4;

                  const sfExpectedAnswers = Array.isArray(step.correctAnswer)
                    ? step.correctAnswer.map((item) => String(item))
                    : [];

                  const sfOnDragOver = (event) => event.preventDefault();

                  const sfDragStartOption = (event, value) => {
                    if (isAnswerChecked) return;
                    event.dataTransfer.setData('text/plain', String(value));
                    event.dataTransfer.effectAllowed = 'move';
                  };

                  const sfPlaceInSlot = (slotIndex, value) => {
                    if (isAnswerChecked) return;
                    if (value === null || value === undefined || value === '') return;
                    setDecisionSipleFormulaData((prev) => {
                      const next = Array.isArray(prev) && prev.length === sfSlotsCount
                        ? [...prev]
                        : Array(sfSlotsCount).fill(null);
                      const existingIndex = next.findIndex((item) => item === String(value));
                      if (existingIndex !== -1 && existingIndex !== slotIndex) {
                        next[existingIndex] = null;
                      }
                      next[slotIndex] = String(value);
                      return next;
                    });
                    setTextButton('Verifica');
                    setChangeColorButton(true);
                  };

                  const sfDropOnSlot = (event, slotIndex) => {
                    event.preventDefault();
                    if (isAnswerChecked) return;
                    const value = event.dataTransfer.getData('text/plain');
                    sfPlaceInSlot(slotIndex, value);
                  };

                  const sfDropOnOptionsArea = (event) => {
                    event.preventDefault();
                    if (isAnswerChecked) return;
                    const value = event.dataTransfer.getData('text/plain');
                    if (!value) return;
                    setDecisionSipleFormulaData((prev) => prev.map((item) => (item === value ? null : item)));
                    setTextButton('Verifica');
                    setChangeColorButton(true);
                  };

                  const sfSlotClick = (slotIndex) => {
                    if (isAnswerChecked) return;
                    setDecisionSipleFormulaData((prev) => {
                      const next = [...prev];
                      next[slotIndex] = null;
                      return next;
                    });
                    setTextButton('Verifica');
                    setChangeColorButton(true);
                  };

                  const sfOptionClick = (value) => {
                    if (isAnswerChecked) return;
                    if (decisionSipleFormulaData.includes(String(value))) return;
                    const firstEmpty = decisionSipleFormulaData.findIndex((item) => item === null || item === undefined);
                    if (firstEmpty === -1) return;
                    sfPlaceInSlot(firstEmpty, value);
                  };

                  const sfDragStartSlot = (event, value) => {
                    if (isAnswerChecked || !value) return;
                    event.dataTransfer.setData('text/plain', String(value));
                    event.dataTransfer.effectAllowed = 'move';
                  };

                  return (
                    <>
                      <div className='siple-formula-slots-cf'>
                        {Array.from({ length: sfSlotsCount }).map((_, slotIndex) => {
                          const value = decisionSipleFormulaData[slotIndex] || '';
                          const expected = sfExpectedAnswers[slotIndex] || '';
                          const isCorrectSlot = isAnswerChecked && value && value === expected;
                          const isWrongSlot = isAnswerChecked && value && value !== expected;

                          return (
                            <button
                              key={`dsf-slot-${slotIndex}`}
                              type="button"
                              className={`siple-formula-slot-cf ${value ? 'filled' : ''} ${isCorrectSlot ? 'correct' : ''} ${isWrongSlot ? 'incorrect' : ''}`}
                              onDragOver={sfOnDragOver}
                              onDrop={(event) => sfDropOnSlot(event, slotIndex)}
                              onClick={() => sfSlotClick(slotIndex)}
                              draggable={!isAnswerChecked && Boolean(value)}
                              onDragStart={(event) => sfDragStartSlot(event, value)}
                              disabled={isAnswerChecked}
                            >
                              <span className='siple-formula-slot-label-cf'></span>
                              <span className='siple-formula-slot-value-cf'>{value}</span>
                            </button>
                          );
                        })}
                      </div>

                      {!isAnswerChecked && (
                        <div
                          className='siple-formula-options-cf'
                          onDragOver={sfOnDragOver}
                          onDrop={sfDropOnOptionsArea}
                        >
                          {sfNormalizedOptions.map((option) => {
                            const isUsed = decisionSipleFormulaData.includes(option.value);
                            return (
                              <button
                                key={option.id}
                                type="button"
                                className={`siple-formula-option-cf ${isUsed ? 'used' : ''}`}
                                draggable={!isUsed}
                                onDragStart={(event) => !isUsed && sfDragStartOption(event, option.value)}
                                onClick={() => !isUsed && sfOptionClick(option.value)}
                                disabled={isUsed}
                              >
                                {!isUsed && option.label}
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </>
                  );
                })()
              ) : step.type === 'decizionDragAndDrop' ? (
                (() => {
                  const normalizedOptions = shuffledDecisionDragOptions.length
                    ? shuffledDecisionDragOptions
                    : (step.options || []).map((value, idx) => ({
                        id: buildDecisionOptionId(idx),
                        value,
                        label: String(value),
                      }));

                  const slotsCount = getDecisionDragSlotsCount(step);
                  const expected = Array.isArray(step.correctAnswer) ? step.correctAnswer : [];
                  const useSimpleFormulaLayout = isDecisionDragSimpleFormulaLayout(step);
                  const rows = Array.isArray(step.rows) && step.rows.length > 0
                    ? step.rows
                    : [{ label: '', slots: slotsCount }];

                  const dndOnDragOver = (event) => {
                    event.preventDefault();
                  };

                  const dndReadDraggedValue = (event) => {
                    try {
                      const payload = event.dataTransfer.getData('application/json');
                      if (payload) {
                        return JSON.parse(payload).id;
                      }
                    } catch (err) {
                      // fallback pentru payload simplu
                    }

                    return event.dataTransfer.getData('text/plain');
                  };

                  const dndDragStartOption = (event, optionId) => {
                    event.dataTransfer.setData('application/json', JSON.stringify({ id: optionId }));
                    event.dataTransfer.setData('text/plain', String(optionId));
                  };

                  const dndPlaceInSlot = (slotIndex, optionId) => {
                    if (isAnswerChecked) return;

                    setDecisionDragAnswers((prev) => {
                      const next = Array.isArray(prev) && prev.length === slotsCount
                        ? [...prev]
                        : Array(slotsCount).fill(null);

                      const existingIndex = next.indexOf(optionId);
                      if (existingIndex !== -1) {
                        next[existingIndex] = null;
                      }

                      next[slotIndex] = optionId;
                      return next;
                    });

                    setTextButton('Verifica');
                    setChangeColorButton(true);
                  };

                  const dndDropOnSlot = (event, slotIndex) => {
                    event.preventDefault();
                    dndPlaceInSlot(slotIndex, dndReadDraggedValue(event));
                  };

                  const dndDropOnOptions = (event) => {
                    event.preventDefault();
                    if (isAnswerChecked) return;

                    const optionId = dndReadDraggedValue(event);
                    setDecisionDragAnswers((prev) => prev.map((item) => (item === optionId ? null : item)));
                    setTextButton('Verifica');
                    setChangeColorButton(true);
                  };

                  const dndSlotClick = (slotIndex) => {
                    if (isAnswerChecked) return;

                    setDecisionDragAnswers((prev) => {
                      const next = [...prev];
                      next[slotIndex] = null;
                      return next;
                    });

                    setTextButton('Verifica');
                    setChangeColorButton(true);
                  };

                  const dndOptionClick = (optionId) => {
                    if (isAnswerChecked) return;
                    const firstEmpty = decisionDragAnswers.findIndex((item) => item === null || item === undefined || item === '');
                    if (firstEmpty !== -1) {
                      dndPlaceInSlot(firstEmpty, optionId);
                    }
                  };

                  const dndDragStartSlot = (event, optionId) => {
                    dndDragStartOption(event, optionId);
                  };

                  let currentIndex = 0;

                  return (
                    <>
                      {useSimpleFormulaLayout ? (
                        <div className='siple-formula-slots-cf'>
                          {Array.from({ length: slotsCount }).map((_, slotIndex) => {
                            const optionId = decisionDragAnswers[slotIndex] ?? null;
                            const value = getDecisionOptionValueById(step, optionId) || '';
                            const expectedValue = expected[slotIndex] ?? '';
                            const isCorrectSlot = isAnswerChecked && value && value === expectedValue;
                            const isWrongSlot = isAnswerChecked && value && value !== expectedValue;

                            return (
                              <button
                                key={`decision-simple-formula-slot-${slotIndex}`}
                                type="button"
                                className={`siple-formula-slot-cf ${value ? 'filled' : ''} ${isCorrectSlot ? 'correct' : ''} ${isWrongSlot ? 'incorrect' : ''}`}
                                onDragOver={dndOnDragOver}
                                onDrop={(event) => dndDropOnSlot(event, slotIndex)}
                                onClick={() => dndSlotClick(slotIndex)}
                                draggable={!isAnswerChecked && Boolean(optionId)}
                                onDragStart={(event) => dndDragStartSlot(event, optionId)}
                                disabled={isAnswerChecked}
                              >
                                <span className='siple-formula-slot-label-cf'></span>
                                <span className='siple-formula-slot-value-cf'>{value}</span>
                              </button>
                            );
                          })}
                        </div>
                      ) : (
                        <div className='decision-dnd-rows-cf'>
                          {rows.map((row, rowIndex) => {
                            const rowSlots = Math.max(0, Number(row?.slots) || 0);
                            const rowLabel = row?.label ?? '';
                            const startIndex = currentIndex;
                            currentIndex += rowSlots;

                            return (
                              <div key={`decision-dnd-row-${rowIndex}`} className='decision-dnd-row-cf'>
                                <p className='decision-dnd-row-label-cf'>{rowLabel}</p>

                                <div className='decision-dnd-slot-row-cf'>
                                  {Array.from({ length: rowSlots }, (_, idx) => {
                                    const slotIndex = startIndex + idx;
                                    const optionId = decisionDragAnswers[slotIndex] ?? null;
                                    const value = getDecisionOptionValueById(step, optionId);
                                    const expectedValue = expected[slotIndex] ?? '';
                                    const isCorrectSlot = isAnswerChecked && value && value === expectedValue;
                                    const isWrongSlot = isAnswerChecked && value && value !== expectedValue;

                                    return (
                                      <button
                                        key={`decision-dnd-slot-${slotIndex}`}
                                        type="button"
                                        className={`decision-dnd-slot-cf ${value ? 'filled' : ''} ${isCorrectSlot ? 'correct' : ''} ${isWrongSlot ? 'incorrect' : ''}`}
                                        onDragOver={dndOnDragOver}
                                        onDrop={(event) => dndDropOnSlot(event, slotIndex)}
                                        onClick={() => dndSlotClick(slotIndex)}
                                        draggable={!isAnswerChecked && Boolean(optionId)}
                                        onDragStart={(event) => dndDragStartSlot(event, optionId)}
                                        disabled={isAnswerChecked}
                                      >
                                        <span className='decision-dnd-slot-value-cf'>{value}</span>
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}

                      {!isAnswerChecked && (
                        <div
                          className={useSimpleFormulaLayout ? 'siple-formula-options-cf' : 'decision-dnd-options-cf'}
                          onDragOver={dndOnDragOver}
                          onDrop={dndDropOnOptions}
                        >
                          {normalizedOptions.map((option) => {
                            const isUsed = decisionDragAnswers.includes(option.id);
                            return (
                              <button
                                key={option.id}
                                type="button"
                                className={`${useSimpleFormulaLayout ? 'siple-formula-option-cf' : 'decision-dnd-option-cf'} ${isUsed ? 'used' : ''}`}
                                draggable={!isUsed}
                                onDragStart={(event) => !isUsed && dndDragStartOption(event, option.id)}
                                onClick={() => !isUsed && dndOptionClick(option.id)}
                                disabled={isUsed}
                              >
                                {!isUsed && option.label}
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </>
                  );
                })()
              ) : step.type === 'dicizionMultiple' ? (
                <div className='multiple-answer-lessons-cf'>
                  {(shuffledDecisionOptions.length ? shuffledDecisionOptions : step.options || []).map((option) => {
                    const isSelected = decisionMultipleAnswers.includes(option);
                    const isCorrect = (step.correctAnswer || []).includes(option);

                    let checkboxClass = 'check-box-multiple-answer-cf';

                    if (isAnswerChecked) {
                      if (isCorrect) {
                        checkboxClass = 'checkbox-correct-cf';
                      } else if (isSelected && !isCorrect) {
                        checkboxClass = 'checkbox-incorrect-cf';
                      }
                    }

                    return (
                      <div
                        key={option}
                        className={`align-multiple-items-cf ${
                          isAnswerChecked
                            ? isCorrect
                              ? 'border-correct-cf'
                              : isSelected
                              ? 'border-incorrect-cf'
                              : ''
                            : isSelected
                            ? 'border-selected-cf'
                            : ''
                        }`}
                        onClick={() => {
                          if (isAnswerChecked) return;

                          setDecisionMultipleAnswers((prev) => {
                            const updated = prev.includes(option)
                              ? prev.filter((answer) => answer !== option)
                              : [...prev, option];

                            setTextButton('Verifica');
                            setChangeColorButton(true);
                            return updated;
                          });
                        }}
                      >
                        <input
                          className={checkboxClass}
                          type="checkbox"
                          checked={isSelected}
                          readOnly
                        />

                        <span className="cursor-pointer-cf">
                          {option}
                        </span>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className='simple-select-buttons-description-cf'>
                  {(shuffledDecisionOptions.length ? shuffledDecisionOptions : step.options || []).map((option) => {
                    let className = 'simple-Button-select-cf';

                    if (isAnswerChecked) {
                      if (option === step.correctAnswer) {
                        className = 'simple-Button-select-correct-cf';
                      } else if (option === decisionAnswer) {
                        className = 'simple-Button-select-incorrect-cf';
                      }
                    } else if (decisionAnswer === option) {
                      className = 'simple-Button-select-colored-cf';
                    }

                    return (
                      <button
                        key={option}
                        className={className}
                        onClick={() => {
                          if (isAnswerChecked) return;
                          setDecisionAnswer(option);
                          setDesableButton(false);
                          setTextButton('Verifica');
                          setChangeColorButton(true);
                        }}
                        disabled={isAnswerChecked}
                      >
                        <p>{option}</p>
                      </button>
                    );
                  })}
                </div>
              )}

              <div className="practice-help-wrapper">
                <button
                  className="practice-help-btn"
                  onClick={() => setShowPracticeHelp(true)}
                  title="Contextul aplicației"
                >
                  <FontAwesomeIcon icon={faCircleInfo} />
                </button>
              </div>
            </div>
          </div>
        );
      }
          
          
          
   

          
          
          
          

        case 'multipleSelect':
          return (
            <div className="quiz-content-scroll-cf">
            <div className='explanation-lesoon-container-cf'>
              <div className='title-simple-select-align-cf'>
                
              <div className="centred-simple-element-cf">
               <span className="question-text-cf">{currentQuestion.question}</span>
              
              </div>  

                  </div>



               




              <div className='multiple-answer-lessons-cf'>
                              {(shuffledMultipleOptions.length ? shuffledMultipleOptions : currentQuestion.options).map(option => {
                                const isSelected = selectedAnswers.includes(option);
                                const isCorrect = currentQuestion.correctAnswer.includes(option);

                                let checkboxClass = 'check-box-multiple-answer-cf';

                                if (isAnswerChecked) {
                                  if (isCorrect) {
                                    checkboxClass = 'checkbox-correct-cf';
                                  } else if (isSelected && !isCorrect) {
                                    checkboxClass = 'checkbox-incorrect-cf';
                                  }
                                }

                                return (
                                  <div
                                    key={option}
                                    className={`align-multiple-items-cf ${
                                      isAnswerChecked
                                        ? isCorrect
                                          ? 'border-correct-cf'
                                          : isSelected
                                          ? 'border-incorrect-cf'
                                          : ''
                                        : isSelected
                                        ? 'border-selected-cf'
                                        : ''
                                    }`}
                                    onClick={() => {
                                      if (isAnswerChecked) return;
                                      handleCheckboxChange(option);
                                    }}
                                  >
                                    <input
                                      className={checkboxClass}
                                      type="checkbox"
                                      checked={isSelected}
                                      readOnly
                                    />

                                    <span className="cursor-pointer-cf">
                                      {option}
                                    </span>
                                  </div>
                                );
                              })}
              </div>
            </div>
            </div>
          );

        case 'lessonResume':
            return (
            <div className='explanation-lesoon-container-resume-cf'>
  <div>
    {currentQuestion.descriptionExplanation.map((description, index) => (
      <div
        key={index}
        className={
          index === 0
            ? 'summary-congrats-cf'      // Felicitări
            : 'summary-next-lesson-cf'   // Lecția următoare
        }
        dangerouslySetInnerHTML={{ __html: description }}
      ></div>
    ))}
  </div>
</div>

          );

        case 'lessonCompletion':
          return (
            <div className='explanation-lesoon-container-resume-cf'>
              <div className="description-lesson-text-explanation-resume-cf">

                <div className="lesson-progress-overlay-cf">
                  <img
                    src={finallessonprogress}
                    alt="Progres lectie"
                    className="lesson-progress-overlay-image-cf"
                  />
                </div>

                {currentQuestion.descriptionExplanation?.map((description, index) => (
                  <div
                    key={index}
                    className="text-size-emplanation-resume-cf"
                    dangerouslySetInnerHTML={{ __html: description }}
                  ></div>
                ))}

                <div className="success-message-bubble-cf bubble-slide-in-left-cf">
                  Felicitari!
                </div>

                <div className="lesson-image-container-cf">
                  <img
                    src={final_congrats_conti}
                    alt="Felicitari finale"
                    className="lesson-image-finishandsend-cf"
                  />
                </div>

                <div className="lesson-completion-progress-wrapper-cf">
                  <p className="completion-progress-label-cf">Lectie finalizata!</p>
                  <div className="lesson-completion-progress-bar-cf">
                    <div
                      className="lesson-completion-progress-fill-cf"
                      onAnimationEnd={() => setIsLessonCompletionBarDoneCf(true)}
                    ></div>
                  </div>
                </div>

               
              </div>
            </div>
          );



      default:
        return <p>Tipul întrebării nu este recunoscut.</p>;
    }

    

  };


  const currentQuestion = lessonData?.questions?.[nextQuestion];
  const currentQuestionType = getQuestionType(currentQuestion);
  const currentExplanation =
    currentQuestionType === 'decisionFlowApplication'
      ? currentQuestion?.steps?.[decisionStepIndex]?.explanation || currentQuestion?.explanation
      : currentQuestion?.explanation;
  const isLessonCompletionScreen = currentQuestionType === 'lessonCompletion';
  const totalCards =
    currentQuestionType === 'explanationLesson'
      ? currentQuestion.descriptionExplanation.length
      : 0;



  return (


    
    <div className='d-flex-cf flex-column-cf justify-content-center-cf align-items-center-cf'>
  
      {/* Bara de progres */}
      <div className='position-progress-bar-cf'>
        {!isLessonFinished && !isLessonCompletionScreen && (
          <StatusProgres 
            width={calculateProgress()}
            coinCount={coinCount}
            onExitClick={handleExitClick}
           
            onEyeClick={handleShowEyePopup} 
          />
        )}
      </div>
  
      {/* Conținutul principal al lecției - păstrat vizibil indiferent de starea isLessonFinished */}
 <SwitchTransition mode="out-in">
  <CSSTransition
    key={nextQuestion} // cheie unică pe fiecare întrebare
    timeout={300}
    classNames="fade-cf"
  >
    <div className='position-main-lesson-cf'>
      {renderContent()}
    </div>
  </CSSTransition>
</SwitchTransition>

      {/* Secțiunea butonului */}





      <div className={`position-button-lesson-cf ${hideActionButton ? 'hide-cf hide-border-top-cf' : ''}`}>

        {showCorrectAnswer && (
          <p className='answer-show-after-button-cf'>
            {isAnswerChecked && simpleCorrectAnswer}
          </p>
        )}
  
       


<div className={`button-group-navigationbc-cf ${hideActionButton ? 'hide-cf' : ''}`}>

<div className={`lesson-navigation-row-cf ${currentQuestion?.type === 'lessonCompletion' ? 'lesson-navigation-row-centered-cf' : ''}`}>


  
        {/* Butonul care se schimbă între "Continuă" și "Finalizează lecția" */}
  {currentQuestionType !== 'explanationLesson' && (
       <button
  className={
    (desableButon || (currentQuestion?.type === 'lessonCompletion' && !isLessonCompletionBarDoneCf))
      ? 'button-next-quiz-desabled-cf'
      : changeColorButton
      ? 'button-next-quiz-verify-cf'
      : 'button-next-quiz-cf'
  }
  onClick={() => {
    if (currentQuestionType === 'lessonCompletion' && !isLessonCompletionBarDoneCf) {
      return;
    }

    if (isLessonFinished) {
      finalizeLesson();
    } else {
      const currentQuestion = lessonData.questions[nextQuestion];
      const currentType = getQuestionType(currentQuestion);

      if (currentType === 'decisionFlowApplication') {
        if (decisionPhase === 'intro') {
          setDecisionPhase('steps');
          setDecisionAnswer(null);
          setDecisionMultipleAnswers([]);
          setDecisionDragAnswers([]);
          setDecisionSipleFormulaData([]);
          setIsAnswerChecked(false);
          setAnswerStatus(null);
          setDesableButton(true);
          setTextButton('Verifica');
          setChangeColorButton(false);
          setHideActionButton(false);
          return;
        }

        if (decisionPhase === 'final') {
          toNextQuestion();
          setHideActionButton(false);
          return;
        }

        if (decisionPhase === 'steps') {
          verifyAnswer();
          setHideActionButton(true);
          setShowFeedback(true);
          return;
        }
      }

      const isExplanationType =
        currentType === 'explanationLesson' ||
        currentType === 'lessonResume' ||
        currentType === 'lessonCompletion';

      if (isAnswerChecked || isExplanationType) {
        toNextQuestion();
        setHideActionButton(false);
      } else {
        verifyAnswer();
        if (!isExplanationType) {
          setHideActionButton(true);
          setShowFeedback(true);
        }
      }
    }
  }}
  disabled={desableButon || (currentQuestionType === 'lessonCompletion' && !isLessonCompletionBarDoneCf)}
>
  {textButton || 'Continua'}
</button>
      )}


{currentQuestionType === 'explanationLesson' && (
  currentQuestion.descriptionExplanation && currentQuestion.descriptionExplanation.length === 1 ? (
    <button
      className="button-explanation-continue-single-cf"
      onClick={() => {
        toNextQuestion();
        setHideActionButton(false);
      }}
    >
      Continua
    </button>
  ) : (
    <button
      className="button-explanation-continue-multi-cf"
      onClick={() => {
        toNextQuestion();
        setHideActionButton(false);
      }}
    >
      Continua
    </button>
  )
)}


{currentQuestionType === 'explanationLesson' && currentQuestion.descriptionExplanation && currentQuestion.descriptionExplanation.length > 1 && (
  <button
    className="button-next-card-bc-cf"
    onClick={() => {
      const targetIndex = (cardIndex + 1) % totalCards;
      updateCardIndexWithSwipe(targetIndex);
    }}
  >
    <img src={changecard} alt="Schimbă cardul" className="change-card-gif-bc-cf" />
  </button>
)}


     
</div>
</div>


      </div>
  
      {/* Alerta de părăsire a lecției */}
   {showAlert && (
  <CustomAlertCf
    onConfirm={handleConfirmExit}
    onCancel={handleCancelExit}
  />
)}



{showFeedback && isAnswerChecked && (
  <FeedbackPopup
    status={answerStatus}
    message={message}
    onClose={handleHideFeedback}
    onContinue={() => {
      if (currentQuestionType === 'decisionFlowApplication') {
        handleHideFeedback();

        if (decisionStepIndex < (currentQuestion?.steps?.length || 0) - 1) {
          setDecisionStepIndex(prev => prev + 1);
          setDecisionAnswer(null);
          setDecisionMultipleAnswers([]);
          setDecisionDragAnswers([]);
          setDecisionSipleFormulaData([]);
          setDecisionMfrData([]);
          setDecisionMflData([]);
          setIsAnswerChecked(false);
          setAnswerStatus(null);
          setDesableButton(true);
          setTextButton('Verifica');
          setChangeColorButton(false);
        } else {
          setDecisionPhase('final');
          setDecisionAnswer(null);
          setDecisionMultipleAnswers([]);
          setDecisionDragAnswers([]);
          setDecisionSipleFormulaData([]);
          setDecisionMfrData([]);
          setDecisionMflData([]);
          setIsAnswerChecked(false);
          setAnswerStatus(null);
          setDesableButton(false);
          setTextButton('Continua');
          setChangeColorButton(false);
        }

        setHideActionButton(false);
        return;
      }

      handleHideFeedback();
      toNextQuestion();
      setHideActionButton(false);
    }}
    onShowAnswer={() => {
      setShowExplanationPopupModal(true);
      handleHideFeedback();
    }}
  />
)}


  {showExplanationPopupModal && currentExplanation && (
  <ExplanationPopup 
      explanation={currentExplanation}
    onContinue={() => {
        setShowExplanationPopupModal(false);

        if (currentQuestionType === 'decisionFlowApplication') {
          if (decisionStepIndex < (currentQuestion?.steps?.length || 0) - 1) {
            setDecisionStepIndex(prev => prev + 1);
            setDecisionAnswer(null);
            setDecisionMultipleAnswers([]);
            setDecisionDragAnswers([]);
            setDecisionSipleFormulaData([]);
            setDecisionMfrData([]);
            setDecisionMflData([]);
            setIsAnswerChecked(false);
            setAnswerStatus(null);
            setDesableButton(true);
            setTextButton('Verifica');
            setChangeColorButton(false);
          } else {
            setDecisionPhase('final');
            setDecisionAnswer(null);
            setDecisionMultipleAnswers([]);
            setDecisionDragAnswers([]);
            setDecisionSipleFormulaData([]);
            setDecisionMfrData([]);
            setDecisionMflData([]);
            setIsAnswerChecked(false);
            setAnswerStatus(null);
            setDesableButton(false);
            setTextButton('Continua');
            setChangeColorButton(false);
          }

          setHideActionButton(false);
          return;
        }

        toNextQuestion();
        setHideActionButton(false);
    }}
  />
)}


{showPracticeHelp && (
  <PracticeHelpPopup
    text={currentQuestion?.context}
    onClose={() => setShowPracticeHelp(false)}
  />
)}



    </div>
  );
  



  
};



export default Chaptercontainercf;